import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AddonType = /*#__PURE__*/function (AddonType) {
  AddonType[AddonType["ADDON_TYPE_UNSPECIFIED"] = 0] = "ADDON_TYPE_UNSPECIFIED";
  AddonType[AddonType["ADDON_TYPE_LD"] = 1] = "ADDON_TYPE_LD";
  AddonType[AddonType["ADDON_TYPE_LSP"] = 2] = "ADDON_TYPE_LSP";
  AddonType[AddonType["ADDON_TYPE_YEXT_HEALTHCARE"] = 3] = "ADDON_TYPE_YEXT_HEALTHCARE";
  AddonType[AddonType["ADDON_TYPE_BRING_YOUR_OWN_YEXT"] = 4] = "ADDON_TYPE_BRING_YOUR_OWN_YEXT";
  AddonType[AddonType["ADDON_TYPE_LISTING_SOURCE"] = 5] = "ADDON_TYPE_LISTING_SOURCE";
  AddonType[AddonType["ADDON_TYPE_KEYWORD_TRACKING"] = 6] = "ADDON_TYPE_KEYWORD_TRACKING";
  AddonType[AddonType["ADDON_TYPE_LSP_EXTENSION"] = 7] = "ADDON_TYPE_LSP_EXTENSION";
  AddonType[AddonType["ADDON_TYPE_YEXT_STANDALONE"] = 8] = "ADDON_TYPE_YEXT_STANDALONE";
  return AddonType;
}(AddonType || {});
var ProviderType = /*#__PURE__*/function (ProviderType) {
  ProviderType[ProviderType["PROVIDER_TYPE_UNSPECIFIED"] = 0] = "PROVIDER_TYPE_UNSPECIFIED";
  ProviderType[ProviderType["PROVIDER_TYPE_UBERALL"] = 1] = "PROVIDER_TYPE_UBERALL";
  ProviderType[ProviderType["PROVIDER_TYPE_YEXT"] = 2] = "PROVIDER_TYPE_YEXT";
  return ProviderType;
}(ProviderType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AccuracyStatus = /*#__PURE__*/function (AccuracyStatus) {
  AccuracyStatus[AccuracyStatus["ACCURACY_STATUS_INVALID"] = 0] = "ACCURACY_STATUS_INVALID";
  AccuracyStatus[AccuracyStatus["ACCURACY_STATUS_UNKNOWN"] = 1] = "ACCURACY_STATUS_UNKNOWN";
  AccuracyStatus[AccuracyStatus["ACCURACY_STATUS_ACCURATE"] = 2] = "ACCURACY_STATUS_ACCURATE";
  AccuracyStatus[AccuracyStatus["ACCURACY_STATUS_INACCURATE"] = 3] = "ACCURACY_STATUS_INACCURATE";
  AccuracyStatus[AccuracyStatus["ACCURACY_STATUS_UNAVAILABLE"] = 4] = "ACCURACY_STATUS_UNAVAILABLE";
  return AccuracyStatus;
}(AccuracyStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Provider = /*#__PURE__*/function (Provider) {
  Provider[Provider["PROVIDER_UNSPECIFIED"] = 0] = "PROVIDER_UNSPECIFIED";
  Provider[Provider["PROVIDER_UBERALL"] = 1] = "PROVIDER_UBERALL";
  Provider[Provider["PROVIDER_YEXT"] = 2] = "PROVIDER_YEXT";
  Provider[Provider["PROVIDER_DIRECT"] = 3] = "PROVIDER_DIRECT";
  return Provider;
}(Provider || {});
var SyncRequirement = /*#__PURE__*/function (SyncRequirement) {
  SyncRequirement[SyncRequirement["SYNC_REQUIREMENT_UNSET"] = 0] = "SYNC_REQUIREMENT_UNSET";
  SyncRequirement[SyncRequirement["SYNC_REQUIREMENT_LSP"] = 1] = "SYNC_REQUIREMENT_LSP";
  SyncRequirement[SyncRequirement["SYNC_REQUIREMENT_PRO_EDITION"] = 2] = "SYNC_REQUIREMENT_PRO_EDITION";
  SyncRequirement[SyncRequirement["SYNC_REQUIREMENT_YEXT_LSP"] = 3] = "SYNC_REQUIREMENT_YEXT_LSP";
  SyncRequirement[SyncRequirement["SYNC_REQUIREMENT_UBERALL_LSP"] = 4] = "SYNC_REQUIREMENT_UBERALL_LSP";
  SyncRequirement[SyncRequirement["SYNC_REQUIREMENT_LSP_OR_PRO_EDITION"] = 5] = "SYNC_REQUIREMENT_LSP_OR_PRO_EDITION";
  return SyncRequirement;
}(SyncRequirement || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DayOfWeek = /*#__PURE__*/function (DayOfWeek) {
  DayOfWeek[DayOfWeek["DAY_OF_WEEK_UNSPECIFIED"] = 0] = "DAY_OF_WEEK_UNSPECIFIED";
  DayOfWeek[DayOfWeek["MONDAY"] = 1] = "MONDAY";
  DayOfWeek[DayOfWeek["TUESDAY"] = 2] = "TUESDAY";
  DayOfWeek[DayOfWeek["WEDNESDAY"] = 3] = "WEDNESDAY";
  DayOfWeek[DayOfWeek["THURSDAY"] = 4] = "THURSDAY";
  DayOfWeek[DayOfWeek["FRIDAY"] = 5] = "FRIDAY";
  DayOfWeek[DayOfWeek["SATURDAY"] = 6] = "SATURDAY";
  DayOfWeek[DayOfWeek["SUNDAY"] = 7] = "SUNDAY";
  return DayOfWeek;
}(DayOfWeek || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ClosedStatus = /*#__PURE__*/function (ClosedStatus) {
  ClosedStatus[ClosedStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  ClosedStatus[ClosedStatus["OPEN"] = 1] = "OPEN";
  ClosedStatus[ClosedStatus["LIMITED"] = 2] = "LIMITED";
  ClosedStatus[ClosedStatus["TEMPORARY"] = 3] = "TEMPORARY";
  ClosedStatus[ClosedStatus["PERMANENT"] = 4] = "PERMANENT";
  return ClosedStatus;
}(ClosedStatus || {});
var HealthCareProfessionalInformationGender = /*#__PURE__*/function (HealthCareProfessionalInformationGender) {
  HealthCareProfessionalInformationGender[HealthCareProfessionalInformationGender["NotSpecified"] = 0] = "NotSpecified";
  HealthCareProfessionalInformationGender[HealthCareProfessionalInformationGender["Female"] = 1] = "Female";
  HealthCareProfessionalInformationGender[HealthCareProfessionalInformationGender["Male"] = 2] = "Male";
  HealthCareProfessionalInformationGender[HealthCareProfessionalInformationGender["Other"] = 3] = "Other";
  return HealthCareProfessionalInformationGender;
}(HealthCareProfessionalInformationGender || {});
var IsAvailable = /*#__PURE__*/function (IsAvailable) {
  IsAvailable[IsAvailable["UNSET"] = 0] = "UNSET";
  IsAvailable[IsAvailable["YES"] = 1] = "YES";
  IsAvailable[IsAvailable["NO"] = 2] = "NO";
  return IsAvailable;
}(IsAvailable || {});
var HealthCareProfessionalInformationIsProvider = /*#__PURE__*/function (HealthCareProfessionalInformationIsProvider) {
  HealthCareProfessionalInformationIsProvider[HealthCareProfessionalInformationIsProvider["IsProviderNotSpecified"] = 0] = "IsProviderNotSpecified";
  HealthCareProfessionalInformationIsProvider[HealthCareProfessionalInformationIsProvider["IsProviderTrue"] = 1] = "IsProviderTrue";
  HealthCareProfessionalInformationIsProvider[HealthCareProfessionalInformationIsProvider["IsProviderFalse"] = 2] = "IsProviderFalse";
  return HealthCareProfessionalInformationIsProvider;
}(HealthCareProfessionalInformationIsProvider || {});
var LifecycleStage = /*#__PURE__*/function (LifecycleStage) {
  LifecycleStage[LifecycleStage["LIFECYCLE_STAGE_UNSET"] = 0] = "LIFECYCLE_STAGE_UNSET";
  LifecycleStage[LifecycleStage["LIFECYCLE_STAGE_LEAD"] = 1] = "LIFECYCLE_STAGE_LEAD";
  LifecycleStage[LifecycleStage["LIFECYCLE_STAGE_PROSPECT"] = 2] = "LIFECYCLE_STAGE_PROSPECT";
  LifecycleStage[LifecycleStage["LIFECYCLE_STAGE_CUSTOMER"] = 3] = "LIFECYCLE_STAGE_CUSTOMER";
  return LifecycleStage;
}(LifecycleStage || {});
var MarketingClassification = /*#__PURE__*/function (MarketingClassification) {
  MarketingClassification[MarketingClassification["MARKETING_CLASSIFICATION_UNUSED"] = 0] = "MARKETING_CLASSIFICATION_UNUSED";
  MarketingClassification[MarketingClassification["MARKETING_CLASSIFICATION_SMB"] = 1] = "MARKETING_CLASSIFICATION_SMB";
  MarketingClassification[MarketingClassification["MARKETING_CLASSIFICATION_SPAM"] = 2] = "MARKETING_CLASSIFICATION_SPAM";
  MarketingClassification[MarketingClassification["MARKETING_CLASSIFICATION_DUPLICATE"] = 3] = "MARKETING_CLASSIFICATION_DUPLICATE";
  MarketingClassification[MarketingClassification["MARKETING_CLASSIFICATION_BLACKLISTED"] = 4] = "MARKETING_CLASSIFICATION_BLACKLISTED";
  MarketingClassification[MarketingClassification["MARKETING_CLASSIFICATION_OUT_OF_MARKET"] = 5] = "MARKETING_CLASSIFICATION_OUT_OF_MARKET";
  return MarketingClassification;
}(MarketingClassification || {});
var RichDataPaymentMethods = /*#__PURE__*/function (RichDataPaymentMethods) {
  RichDataPaymentMethods[RichDataPaymentMethods["AMERICAN_EXPRESS"] = 0] = "AMERICAN_EXPRESS";
  RichDataPaymentMethods[RichDataPaymentMethods["ANDROID_PAY"] = 1] = "ANDROID_PAY";
  RichDataPaymentMethods[RichDataPaymentMethods["APPLE_PAY"] = 2] = "APPLE_PAY";
  RichDataPaymentMethods[RichDataPaymentMethods["CASH"] = 3] = "CASH";
  RichDataPaymentMethods[RichDataPaymentMethods["CHECK"] = 4] = "CHECK";
  RichDataPaymentMethods[RichDataPaymentMethods["DEBIT"] = 5] = "DEBIT";
  RichDataPaymentMethods[RichDataPaymentMethods["DINERS_CLUB"] = 6] = "DINERS_CLUB";
  RichDataPaymentMethods[RichDataPaymentMethods["DISCOVER"] = 7] = "DISCOVER";
  RichDataPaymentMethods[RichDataPaymentMethods["MASTERCARD"] = 8] = "MASTERCARD";
  RichDataPaymentMethods[RichDataPaymentMethods["PAYPAL"] = 9] = "PAYPAL";
  RichDataPaymentMethods[RichDataPaymentMethods["SAMSUNG_PAY"] = 10] = "SAMSUNG_PAY";
  RichDataPaymentMethods[RichDataPaymentMethods["STORE_CARD"] = 11] = "STORE_CARD";
  RichDataPaymentMethods[RichDataPaymentMethods["TRAVELERS_CHECK"] = 12] = "TRAVELERS_CHECK";
  RichDataPaymentMethods[RichDataPaymentMethods["VISA"] = 13] = "VISA";
  RichDataPaymentMethods[RichDataPaymentMethods["CCS"] = 14] = "CCS";
  RichDataPaymentMethods[RichDataPaymentMethods["SODEXO"] = 15] = "SODEXO";
  RichDataPaymentMethods[RichDataPaymentMethods["GOPAY"] = 16] = "GOPAY";
  RichDataPaymentMethods[RichDataPaymentMethods["V_PAY"] = 17] = "V_PAY";
  RichDataPaymentMethods[RichDataPaymentMethods["FINANCING"] = 18] = "FINANCING";
  RichDataPaymentMethods[RichDataPaymentMethods["INVOICE"] = 19] = "INVOICE";
  RichDataPaymentMethods[RichDataPaymentMethods["PAYSEC"] = 20] = "PAYSEC";
  RichDataPaymentMethods[RichDataPaymentMethods["BITCOIN"] = 21] = "BITCOIN";
  return RichDataPaymentMethods;
}(RichDataPaymentMethods || {});
var ServiceAreaBusinessType = /*#__PURE__*/function (ServiceAreaBusinessType) {
  ServiceAreaBusinessType[ServiceAreaBusinessType["SERVICE_AREA_BUSINESS_TYPE_UNSPECIFIED"] = 0] = "SERVICE_AREA_BUSINESS_TYPE_UNSPECIFIED";
  ServiceAreaBusinessType[ServiceAreaBusinessType["SERVICE_AREA_BUSINESS_TYPE_CUSTOMER_LOCATION_ONLY"] = 1] = "SERVICE_AREA_BUSINESS_TYPE_CUSTOMER_LOCATION_ONLY";
  ServiceAreaBusinessType[ServiceAreaBusinessType["SERVICE_AREA_BUSINESS_TYPE_CUSTOMER_AND_BUSINESS_LOCATION"] = 2] = "SERVICE_AREA_BUSINESS_TYPE_CUSTOMER_AND_BUSINESS_LOCATION";
  return ServiceAreaBusinessType;
}(ServiceAreaBusinessType || {});
var SpecialHoursStatus = /*#__PURE__*/function (SpecialHoursStatus) {
  SpecialHoursStatus[SpecialHoursStatus["SPECIAL_HOURS_STATUS_INVALID"] = 0] = "SPECIAL_HOURS_STATUS_INVALID";
  SpecialHoursStatus[SpecialHoursStatus["SPECIAL_HOURS_STATUS_OPEN"] = 1] = "SPECIAL_HOURS_STATUS_OPEN";
  SpecialHoursStatus[SpecialHoursStatus["SPECIAL_HOURS_STATUS_CLOSED"] = 2] = "SPECIAL_HOURS_STATUS_CLOSED";
  SpecialHoursStatus[SpecialHoursStatus["SPECIAL_HOURS_STATUS_UNCONFIRMED_HOLIDAY"] = 3] = "SPECIAL_HOURS_STATUS_UNCONFIRMED_HOLIDAY";
  return SpecialHoursStatus;
}(SpecialHoursStatus || {});
var ValueType = /*#__PURE__*/function (ValueType) {
  ValueType[ValueType["ATTRIBUTE_VALUE_TYPE_UNSPECIFIED"] = 0] = "ATTRIBUTE_VALUE_TYPE_UNSPECIFIED";
  ValueType[ValueType["BOOL"] = 1] = "BOOL";
  ValueType[ValueType["ENUM"] = 2] = "ENUM";
  ValueType[ValueType["URL"] = 3] = "URL";
  ValueType[ValueType["REPEATED_ENUM"] = 4] = "REPEATED_ENUM";
  ValueType[ValueType["INTEGER"] = 5] = "INTEGER";
  return ValueType;
}(ValueType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var UpdateOption = /*#__PURE__*/function (UpdateOption) {
  UpdateOption[UpdateOption["UPDATE_OPTION_UNSPECIFIED"] = 0] = "UPDATE_OPTION_UNSPECIFIED";
  UpdateOption[UpdateOption["UPDATE_OPTION_IMPROVE_WRITING"] = 1] = "UPDATE_OPTION_IMPROVE_WRITING";
  UpdateOption[UpdateOption["UPDATE_OPTION_SPELLING_AND_GRAMMAR"] = 2] = "UPDATE_OPTION_SPELLING_AND_GRAMMAR";
  UpdateOption[UpdateOption["UPDATE_OPTION_MAKE_SHORTER"] = 3] = "UPDATE_OPTION_MAKE_SHORTER";
  UpdateOption[UpdateOption["UPDATE_OPTION_OPTIMIZE_BY_KEYWORDS"] = 4] = "UPDATE_OPTION_OPTIMIZE_BY_KEYWORDS";
  UpdateOption[UpdateOption["UPDATE_OPTION_CHANGE_TONE"] = 5] = "UPDATE_OPTION_CHANGE_TONE";
  return UpdateOption;
}(UpdateOption || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AddonActivationAddonActivationStatus = /*#__PURE__*/function (AddonActivationAddonActivationStatus) {
  AddonActivationAddonActivationStatus[AddonActivationAddonActivationStatus["ACTIVATION_STATUS_NOT_SPECIFIED"] = 0] = "ACTIVATION_STATUS_NOT_SPECIFIED";
  AddonActivationAddonActivationStatus[AddonActivationAddonActivationStatus["ACTIVATION_STATUS_ACTIVATED"] = 1] = "ACTIVATION_STATUS_ACTIVATED";
  AddonActivationAddonActivationStatus[AddonActivationAddonActivationStatus["ACTIVATION_STATUS_PENDING"] = 2] = "ACTIVATION_STATUS_PENDING";
  AddonActivationAddonActivationStatus[AddonActivationAddonActivationStatus["ACTIVATION_STATUS_CANCELED"] = 3] = "ACTIVATION_STATUS_CANCELED";
  AddonActivationAddonActivationStatus[AddonActivationAddonActivationStatus["ACTIVATION_STATUS_DEACTIVATED"] = 4] = "ACTIVATION_STATUS_DEACTIVATED";
  return AddonActivationAddonActivationStatus;
}(AddonActivationAddonActivationStatus || {});
var GBPClaimStatus = /*#__PURE__*/function (GBPClaimStatus) {
  GBPClaimStatus[GBPClaimStatus["GBP_CLAIM_STATUS_INVALID"] = 0] = "GBP_CLAIM_STATUS_INVALID";
  GBPClaimStatus[GBPClaimStatus["GBP_CLAIM_STATUS_UNKNOWN"] = 1] = "GBP_CLAIM_STATUS_UNKNOWN";
  GBPClaimStatus[GBPClaimStatus["GBP_CLAIM_STATUS_CLAIMED"] = 2] = "GBP_CLAIM_STATUS_CLAIMED";
  GBPClaimStatus[GBPClaimStatus["GBP_CLAIM_STATUS_UNCLAIMED"] = 3] = "GBP_CLAIM_STATUS_UNCLAIMED";
  return GBPClaimStatus;
}(GBPClaimStatus || {});
var Vicinity = /*#__PURE__*/function (Vicinity) {
  Vicinity[Vicinity["VICINITY_UNDEFINED"] = 0] = "VICINITY_UNDEFINED";
  Vicinity[Vicinity["VICINITY_CITY"] = 1] = "VICINITY_CITY";
  Vicinity[Vicinity["VICINITY_A1"] = 2] = "VICINITY_A1";
  Vicinity[Vicinity["VICINITY_A2"] = 3] = "VICINITY_A2";
  Vicinity[Vicinity["VICINITY_A3"] = 4] = "VICINITY_A3";
  Vicinity[Vicinity["VICINITY_A4"] = 5] = "VICINITY_A4";
  Vicinity[Vicinity["VICINITY_A5"] = 6] = "VICINITY_A5";
  Vicinity[Vicinity["VICINITY_B1"] = 7] = "VICINITY_B1";
  Vicinity[Vicinity["VICINITY_B2"] = 8] = "VICINITY_B2";
  Vicinity[Vicinity["VICINITY_B3"] = 9] = "VICINITY_B3";
  Vicinity[Vicinity["VICINITY_B4"] = 10] = "VICINITY_B4";
  Vicinity[Vicinity["VICINITY_B5"] = 11] = "VICINITY_B5";
  Vicinity[Vicinity["VICINITY_C1"] = 12] = "VICINITY_C1";
  Vicinity[Vicinity["VICINITY_C2"] = 13] = "VICINITY_C2";
  Vicinity[Vicinity["VICINITY_C3"] = 14] = "VICINITY_C3";
  Vicinity[Vicinity["VICINITY_C4"] = 15] = "VICINITY_C4";
  Vicinity[Vicinity["VICINITY_C5"] = 16] = "VICINITY_C5";
  Vicinity[Vicinity["VICINITY_D1"] = 17] = "VICINITY_D1";
  Vicinity[Vicinity["VICINITY_D2"] = 18] = "VICINITY_D2";
  Vicinity[Vicinity["VICINITY_D3"] = 19] = "VICINITY_D3";
  Vicinity[Vicinity["VICINITY_D4"] = 20] = "VICINITY_D4";
  Vicinity[Vicinity["VICINITY_D5"] = 21] = "VICINITY_D5";
  Vicinity[Vicinity["VICINITY_E1"] = 22] = "VICINITY_E1";
  Vicinity[Vicinity["VICINITY_E2"] = 23] = "VICINITY_E2";
  Vicinity[Vicinity["VICINITY_E3"] = 24] = "VICINITY_E3";
  Vicinity[Vicinity["VICINITY_E4"] = 25] = "VICINITY_E4";
  Vicinity[Vicinity["VICINITY_E5"] = 26] = "VICINITY_E5";
  return Vicinity;
}(Vicinity || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SyncStatus = /*#__PURE__*/function (SyncStatus) {
  SyncStatus[SyncStatus["SYNC_STATUS_UNSET"] = 0] = "SYNC_STATUS_UNSET";
  SyncStatus[SyncStatus["SYNC_STATUS_SYNCING"] = 1] = "SYNC_STATUS_SYNCING";
  SyncStatus[SyncStatus["SYNC_STATUS_PARTIALLY_SYNCED"] = 2] = "SYNC_STATUS_PARTIALLY_SYNCED";
  SyncStatus[SyncStatus["SYNC_STATUS_SUCCESS"] = 3] = "SYNC_STATUS_SUCCESS";
  SyncStatus[SyncStatus["SYNC_STATUS_FAILED"] = 4] = "SYNC_STATUS_FAILED";
  SyncStatus[SyncStatus["SYNC_STATUS_CLAIMED"] = 6] = "SYNC_STATUS_CLAIMED";
  SyncStatus[SyncStatus["SYNC_STATUS_UNAVAILABLE"] = 5] = "SYNC_STATUS_UNAVAILABLE";
  SyncStatus[SyncStatus["SYNC_STATUS_SUBMITTED"] = 7] = "SYNC_STATUS_SUBMITTED";
  return SyncStatus;
}(SyncStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$f(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$e(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddonAttributes {
  static fromProto(proto) {
    let m = new AddonAttributes();
    m = Object.assign(m, proto);
    if (proto.addonType) {
      m.addonType = enumStringToValue$e(AddonType, proto.addonType);
    }
    if (proto.providerType) {
      m.providerType = enumStringToValue$e(ProviderType, proto.providerType);
    }
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonType !== 'undefined') {
      toReturn['addonType'] = this.addonType;
    }
    if (typeof this.providerType !== 'undefined') {
      toReturn['providerType'] = this.providerType;
    }
    if (typeof this.providerPlanId !== 'undefined') {
      toReturn['providerPlanId'] = this.providerPlanId;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    return toReturn;
  }
}
class GetMultiAddonAttributesResponseAddonAttributesEntry {
  static fromProto(proto) {
    let m = new GetMultiAddonAttributesResponseAddonAttributesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = AddonAttributes.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class CreateAddonAttributesRequest {
  static fromProto(proto) {
    let m = new CreateAddonAttributesRequest();
    m = Object.assign(m, proto);
    if (proto.addonAttributes) {
      m.addonAttributes = AddonAttributes.fromProto(proto.addonAttributes);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.addonAttributes !== 'undefined' && this.addonAttributes !== null) {
      toReturn['addonAttributes'] = 'toApiJson' in this.addonAttributes ? this.addonAttributes.toApiJson() : this.addonAttributes;
    }
    return toReturn;
  }
}
class DeleteAddonAttributesRequest {
  static fromProto(proto) {
    let m = new DeleteAddonAttributesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    return toReturn;
  }
}
class GetAddonAttributesRequest {
  static fromProto(proto) {
    let m = new GetAddonAttributesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    return toReturn;
  }
}
class GetAddonAttributesResponse {
  static fromProto(proto) {
    let m = new GetAddonAttributesResponse();
    m = Object.assign(m, proto);
    if (proto.addonAttributes) {
      m.addonAttributes = AddonAttributes.fromProto(proto.addonAttributes);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.addonAttributes !== 'undefined' && this.addonAttributes !== null) {
      toReturn['addonAttributes'] = 'toApiJson' in this.addonAttributes ? this.addonAttributes.toApiJson() : this.addonAttributes;
    }
    return toReturn;
  }
}
class GetMultiAddonAttributesRequest {
  static fromProto(proto) {
    let m = new GetMultiAddonAttributesRequest();
    m = Object.assign(m, proto);
    if (proto.addonTypes) {
      m.addonTypes = proto.addonTypes.map(v => enumStringToValue$e(AddonType, v));
    }
    if (proto.providerTypes) {
      m.providerTypes = proto.providerTypes.map(v => enumStringToValue$e(ProviderType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonIds !== 'undefined') {
      toReturn['addonIds'] = this.addonIds;
    }
    if (typeof this.addonTypes !== 'undefined') {
      toReturn['addonTypes'] = this.addonTypes;
    }
    if (typeof this.providerTypes !== 'undefined') {
      toReturn['providerTypes'] = this.providerTypes;
    }
    return toReturn;
  }
}
class GetMultiAddonAttributesResponse {
  static fromProto(proto) {
    let m = new GetMultiAddonAttributesResponse();
    m = Object.assign(m, proto);
    if (proto.addonAttributes) {
      m.addonAttributes = Object.keys(proto.addonAttributes).reduce((obj, k) => {
        obj[k] = AddonAttributes.fromProto(proto.addonAttributes[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonAttributes !== 'undefined' && this.addonAttributes !== null) {
      toReturn['addonAttributes'] = 'toApiJson' in this.addonAttributes ? this.addonAttributes.toApiJson() : this.addonAttributes;
    }
    return toReturn;
  }
}
class UpdateAddonAttributesRequest {
  static fromProto(proto) {
    let m = new UpdateAddonAttributesRequest();
    m = Object.assign(m, proto);
    if (proto.addonAttributes) {
      m.addonAttributes = AddonAttributes.fromProto(proto.addonAttributes);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.addonAttributes !== 'undefined' && this.addonAttributes !== null) {
      toReturn['addonAttributes'] = 'toApiJson' in this.addonAttributes ? this.addonAttributes.toApiJson() : this.addonAttributes;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue$d(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$c(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetGoogleMyBusinessInsightsDataBucketedRequest {
  static fromProto(proto) {
    let m = new GetGoogleMyBusinessInsightsDataBucketedRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class GetGoogleMyBusinessInsightsDataBucketedResponse {
  static fromProto(proto) {
    let m = new GetGoogleMyBusinessInsightsDataBucketedResponse();
    m = Object.assign(m, proto);
    if (proto.actionsDrivingDirections) {
      m.actionsDrivingDirections = InsightBucketed.fromProto(proto.actionsDrivingDirections);
    }
    if (proto.actionsPhone) {
      m.actionsPhone = InsightBucketed.fromProto(proto.actionsPhone);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionsDrivingDirections !== 'undefined' && this.actionsDrivingDirections !== null) {
      toReturn['actionsDrivingDirections'] = 'toApiJson' in this.actionsDrivingDirections ? this.actionsDrivingDirections.toApiJson() : this.actionsDrivingDirections;
    }
    if (typeof this.actionsPhone !== 'undefined' && this.actionsPhone !== null) {
      toReturn['actionsPhone'] = 'toApiJson' in this.actionsPhone ? this.actionsPhone.toApiJson() : this.actionsPhone;
    }
    return toReturn;
  }
}
class GetGoogleMyBusinessInsightsDataRequest {
  static fromProto(proto) {
    let m = new GetGoogleMyBusinessInsightsDataRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class GetGoogleMyBusinessInsightsDataResponse {
  static fromProto(proto) {
    let m = new GetGoogleMyBusinessInsightsDataResponse();
    m = Object.assign(m, proto);
    if (proto.actionsDrivingDirections) {
      m.actionsDrivingDirections = proto.actionsDrivingDirections.map(Insight.fromProto);
    }
    if (proto.actionsPhone) {
      m.actionsPhone = proto.actionsPhone.map(Insight.fromProto);
    }
    if (proto.actionsWebsite) {
      m.actionsWebsite = proto.actionsWebsite.map(Insight.fromProto);
    }
    if (proto.localPostActionsCallToAction) {
      m.localPostActionsCallToAction = proto.localPostActionsCallToAction.map(Insight.fromProto);
    }
    if (proto.localPostViewsSearch) {
      m.localPostViewsSearch = proto.localPostViewsSearch.map(Insight.fromProto);
    }
    if (proto.photosCountCustomers) {
      m.photosCountCustomers = proto.photosCountCustomers.map(Insight.fromProto);
    }
    if (proto.photosCountMerchant) {
      m.photosCountMerchant = proto.photosCountMerchant.map(Insight.fromProto);
    }
    if (proto.photosViewsCustomers) {
      m.photosViewsCustomers = proto.photosViewsCustomers.map(Insight.fromProto);
    }
    if (proto.photosViewsMerchant) {
      m.photosViewsMerchant = proto.photosViewsMerchant.map(Insight.fromProto);
    }
    if (proto.queriesChain) {
      m.queriesChain = proto.queriesChain.map(Insight.fromProto);
    }
    if (proto.queriesDirect) {
      m.queriesDirect = proto.queriesDirect.map(Insight.fromProto);
    }
    if (proto.queriesIndirect) {
      m.queriesIndirect = proto.queriesIndirect.map(Insight.fromProto);
    }
    if (proto.viewsMaps) {
      m.viewsMaps = proto.viewsMaps.map(Insight.fromProto);
    }
    if (proto.viewsSearch) {
      m.viewsSearch = proto.viewsSearch.map(Insight.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionsDrivingDirections !== 'undefined' && this.actionsDrivingDirections !== null) {
      toReturn['actionsDrivingDirections'] = 'toApiJson' in this.actionsDrivingDirections ? this.actionsDrivingDirections.toApiJson() : this.actionsDrivingDirections;
    }
    if (typeof this.actionsPhone !== 'undefined' && this.actionsPhone !== null) {
      toReturn['actionsPhone'] = 'toApiJson' in this.actionsPhone ? this.actionsPhone.toApiJson() : this.actionsPhone;
    }
    if (typeof this.actionsWebsite !== 'undefined' && this.actionsWebsite !== null) {
      toReturn['actionsWebsite'] = 'toApiJson' in this.actionsWebsite ? this.actionsWebsite.toApiJson() : this.actionsWebsite;
    }
    if (typeof this.localPostActionsCallToAction !== 'undefined' && this.localPostActionsCallToAction !== null) {
      toReturn['localPostActionsCallToAction'] = 'toApiJson' in this.localPostActionsCallToAction ? this.localPostActionsCallToAction.toApiJson() : this.localPostActionsCallToAction;
    }
    if (typeof this.localPostViewsSearch !== 'undefined' && this.localPostViewsSearch !== null) {
      toReturn['localPostViewsSearch'] = 'toApiJson' in this.localPostViewsSearch ? this.localPostViewsSearch.toApiJson() : this.localPostViewsSearch;
    }
    if (typeof this.photosCountCustomers !== 'undefined' && this.photosCountCustomers !== null) {
      toReturn['photosCountCustomers'] = 'toApiJson' in this.photosCountCustomers ? this.photosCountCustomers.toApiJson() : this.photosCountCustomers;
    }
    if (typeof this.photosCountMerchant !== 'undefined' && this.photosCountMerchant !== null) {
      toReturn['photosCountMerchant'] = 'toApiJson' in this.photosCountMerchant ? this.photosCountMerchant.toApiJson() : this.photosCountMerchant;
    }
    if (typeof this.photosViewsCustomers !== 'undefined' && this.photosViewsCustomers !== null) {
      toReturn['photosViewsCustomers'] = 'toApiJson' in this.photosViewsCustomers ? this.photosViewsCustomers.toApiJson() : this.photosViewsCustomers;
    }
    if (typeof this.photosViewsMerchant !== 'undefined' && this.photosViewsMerchant !== null) {
      toReturn['photosViewsMerchant'] = 'toApiJson' in this.photosViewsMerchant ? this.photosViewsMerchant.toApiJson() : this.photosViewsMerchant;
    }
    if (typeof this.queriesChain !== 'undefined' && this.queriesChain !== null) {
      toReturn['queriesChain'] = 'toApiJson' in this.queriesChain ? this.queriesChain.toApiJson() : this.queriesChain;
    }
    if (typeof this.queriesDirect !== 'undefined' && this.queriesDirect !== null) {
      toReturn['queriesDirect'] = 'toApiJson' in this.queriesDirect ? this.queriesDirect.toApiJson() : this.queriesDirect;
    }
    if (typeof this.queriesIndirect !== 'undefined' && this.queriesIndirect !== null) {
      toReturn['queriesIndirect'] = 'toApiJson' in this.queriesIndirect ? this.queriesIndirect.toApiJson() : this.queriesIndirect;
    }
    if (typeof this.viewsMaps !== 'undefined' && this.viewsMaps !== null) {
      toReturn['viewsMaps'] = 'toApiJson' in this.viewsMaps ? this.viewsMaps.toApiJson() : this.viewsMaps;
    }
    if (typeof this.viewsSearch !== 'undefined' && this.viewsSearch !== null) {
      toReturn['viewsSearch'] = 'toApiJson' in this.viewsSearch ? this.viewsSearch.toApiJson() : this.viewsSearch;
    }
    return toReturn;
  }
}
class Insight {
  static fromProto(proto) {
    let m = new Insight();
    m = Object.assign(m, proto);
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class InsightBucket {
  static fromProto(proto) {
    let m = new InsightBucket();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.bucketLabel !== 'undefined') {
      toReturn['bucketLabel'] = this.bucketLabel;
    }
    return toReturn;
  }
}
class InsightBucketed {
  static fromProto(proto) {
    let m = new InsightBucketed();
    m = Object.assign(m, proto);
    if (proto.buckets) {
      m.buckets = proto.buckets.map(InsightBucket.fromProto);
    }
    if (proto.totalAcrossBuckets) {
      m.totalAcrossBuckets = parseInt(proto.totalAcrossBuckets, 10);
    }
    if (proto.totalChangeAcrossBuckets) {
      m.totalChangeAcrossBuckets = parseInt(proto.totalChangeAcrossBuckets, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.buckets !== 'undefined' && this.buckets !== null) {
      toReturn['buckets'] = 'toApiJson' in this.buckets ? this.buckets.toApiJson() : this.buckets;
    }
    if (typeof this.totalAcrossBuckets !== 'undefined') {
      toReturn['totalAcrossBuckets'] = this.totalAcrossBuckets;
    }
    if (typeof this.totalChangeAcrossBuckets !== 'undefined') {
      toReturn['totalChangeAcrossBuckets'] = this.totalChangeAcrossBuckets;
    }
    return toReturn;
  }
}
function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AnchorData {
  static fromProto(proto) {
    let m = new AnchorData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    return toReturn;
  }
}
class AnchorDataMatches {
  static fromProto(proto) {
    let m = new AnchorDataMatches();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    return toReturn;
  }
}
class FetchAndSubmitSourceURLsToCSRequest {
  static fromProto(proto) {
    let m = new FetchAndSubmitSourceURLsToCSRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.vendorIds !== 'undefined') {
      toReturn['vendorIds'] = this.vendorIds;
    }
    return toReturn;
  }
}
class GetSyndicationInfoRequest {
  static fromProto(proto) {
    let m = new GetSyndicationInfoRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.vendorId !== 'undefined') {
      toReturn['vendorId'] = this.vendorId;
    }
    return toReturn;
  }
}
class GetSyndicationInfoResponse {
  static fromProto(proto) {
    let m = new GetSyndicationInfoResponse();
    m = Object.assign(m, proto);
    if (proto.syndicationInfo) {
      m.syndicationInfo = proto.syndicationInfo.map(SyndicationInfo.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.syndicationInfo !== 'undefined' && this.syndicationInfo !== null) {
      toReturn['syndicationInfo'] = 'toApiJson' in this.syndicationInfo ? this.syndicationInfo.toApiJson() : this.syndicationInfo;
    }
    return toReturn;
  }
}
class SourceAccuracy {
  static fromProto(proto) {
    let m = new SourceAccuracy();
    m = Object.assign(m, proto);
    if (proto.anchorData) {
      m.anchorData = AnchorData.fromProto(proto.anchorData);
    }
    if (proto.anchorDataMatches) {
      m.anchorDataMatches = AnchorDataMatches.fromProto(proto.anchorDataMatches);
    }
    if (proto.status) {
      m.status = enumStringToValue$b(AccuracyStatus, proto.status);
    }
    if (proto.lastScraped) {
      m.lastScraped = new Date(proto.lastScraped);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.anchorData !== 'undefined' && this.anchorData !== null) {
      toReturn['anchorData'] = 'toApiJson' in this.anchorData ? this.anchorData.toApiJson() : this.anchorData;
    }
    if (typeof this.anchorDataMatches !== 'undefined' && this.anchorDataMatches !== null) {
      toReturn['anchorDataMatches'] = 'toApiJson' in this.anchorDataMatches ? this.anchorDataMatches.toApiJson() : this.anchorDataMatches;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.lastScraped !== 'undefined' && this.lastScraped !== null) {
      toReturn['lastScraped'] = 'toApiJson' in this.lastScraped ? this.lastScraped.toApiJson() : this.lastScraped;
    }
    return toReturn;
  }
}
class SubmitTurboListerRequest {
  static fromProto(proto) {
    let m = new SubmitTurboListerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.vendorId !== 'undefined') {
      toReturn['vendorId'] = this.vendorId;
    }
    if (typeof this.force !== 'undefined') {
      toReturn['force'] = this.force;
    }
    return toReturn;
  }
}
class SubmitTurboListerResponse {
  static fromProto(proto) {
    let m = new SubmitTurboListerResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rejectedReason !== 'undefined') {
      toReturn['rejectedReason'] = this.rejectedReason;
    }
    return toReturn;
  }
}
class SyndicationInfo {
  static fromProto(proto) {
    let m = new SyndicationInfo();
    m = Object.assign(m, proto);
    if (proto.lastAttempted) {
      m.lastAttempted = new Date(proto.lastAttempted);
    }
    if (proto.lastSucceeded) {
      m.lastSucceeded = new Date(proto.lastSucceeded);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorId !== 'undefined') {
      toReturn['vendorId'] = this.vendorId;
    }
    if (typeof this.lastAttempted !== 'undefined' && this.lastAttempted !== null) {
      toReturn['lastAttempted'] = 'toApiJson' in this.lastAttempted ? this.lastAttempted.toApiJson() : this.lastAttempted;
    }
    if (typeof this.lastSucceeded !== 'undefined' && this.lastSucceeded !== null) {
      toReturn['lastSucceeded'] = 'toApiJson' in this.lastSucceeded ? this.lastSucceeded.toApiJson() : this.lastSucceeded;
    }
    if (typeof this.lastWorkflowUrl !== 'undefined') {
      toReturn['lastWorkflowUrl'] = this.lastWorkflowUrl;
    }
    return toReturn;
  }
}
function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DeleteListingSourceRequest {
  static fromProto(proto) {
    let m = new DeleteListingSourceRequest();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    return toReturn;
  }
}
class GetListingSourceByProviderIdRequest {
  static fromProto(proto) {
    let m = new GetListingSourceByProviderIdRequest();
    m = Object.assign(m, proto);
    if (proto.provider) {
      m.provider = enumStringToValue$a(Provider, proto.provider);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.provider !== 'undefined') {
      toReturn['provider'] = this.provider;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetListingSourceByProviderIdResponse {
  static fromProto(proto) {
    let m = new GetListingSourceByProviderIdResponse();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = Source.fromProto(proto.source);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.source !== 'undefined' && this.source !== null) {
      toReturn['source'] = 'toApiJson' in this.source ? this.source.toApiJson() : this.source;
    }
    return toReturn;
  }
}
class GetPartnerSourcesRequest {
  static fromProto(proto) {
    let m = new GetPartnerSourcesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetPartnerSourcesResponse {
  static fromProto(proto) {
    let m = new GetPartnerSourcesResponse();
    m = Object.assign(m, proto);
    if (proto.sources) {
      m.sources = Object.keys(proto.sources).reduce((obj, k) => {
        obj[k] = Source.fromProto(proto.sources[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sources !== 'undefined' && this.sources !== null) {
      toReturn['sources'] = 'toApiJson' in this.sources ? this.sources.toApiJson() : this.sources;
    }
    return toReturn;
  }
}
class LocationOverride {
  static fromProto(proto) {
    let m = new LocationOverride();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ignoredAnchorDataMatches !== 'undefined') {
      toReturn['ignoredAnchorDataMatches'] = this.ignoredAnchorDataMatches;
    }
    if (typeof this.submitListingValidationRegex !== 'undefined') {
      toReturn['submitListingValidationRegex'] = this.submitListingValidationRegex;
    }
    return toReturn;
  }
}
class SourceLocationSpecificOverridesEntry {
  static fromProto(proto) {
    let m = new SourceLocationSpecificOverridesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = LocationOverride.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class PartnerOverride {
  static fromProto(proto) {
    let m = new PartnerOverride();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.adminNotes !== 'undefined') {
      toReturn['adminNotes'] = this.adminNotes;
    }
    if (typeof this.createListingHtml !== 'undefined') {
      toReturn['createListingHtml'] = this.createListingHtml;
    }
    if (typeof this.claimListingHtml !== 'undefined') {
      toReturn['claimListingHtml'] = this.claimListingHtml;
    }
    if (typeof this.descriptionHtml !== 'undefined') {
      toReturn['descriptionHtml'] = this.descriptionHtml;
    }
    if (typeof this.editListingHtml !== 'undefined') {
      toReturn['editListingHtml'] = this.editListingHtml;
    }
    if (typeof this.editListingUrl !== 'undefined') {
      toReturn['editListingUrl'] = this.editListingUrl;
    }
    if (typeof this.iconClass16px !== 'undefined') {
      toReturn['iconClass16px'] = this.iconClass16px;
    }
    if (typeof this.iconClass32px !== 'undefined') {
      toReturn['iconClass32px'] = this.iconClass32px;
    }
    if (typeof this.iconClass50px !== 'undefined') {
      toReturn['iconClass50px'] = this.iconClass50px;
    }
    if (typeof this.iconUrl16px !== 'undefined') {
      toReturn['iconUrl16px'] = this.iconUrl16px;
    }
    if (typeof this.iconUrl32px !== 'undefined') {
      toReturn['iconUrl32px'] = this.iconUrl32px;
    }
    if (typeof this.iconUrl50px !== 'undefined') {
      toReturn['iconUrl50px'] = this.iconUrl50px;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class SourcePartnerSpecificOverridesEntry {
  static fromProto(proto) {
    let m = new SourcePartnerSpecificOverridesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = PartnerOverride.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class Source {
  static fromProto(proto) {
    let m = new Source();
    m = Object.assign(m, proto);
    if (proto.locationSpecificOverrides) {
      m.locationSpecificOverrides = Object.keys(proto.locationSpecificOverrides).reduce((obj, k) => {
        obj[k] = LocationOverride.fromProto(proto.locationSpecificOverrides[k]);
        return obj;
      }, {});
    }
    if (proto.partnerSpecificOverrides) {
      m.partnerSpecificOverrides = Object.keys(proto.partnerSpecificOverrides).reduce((obj, k) => {
        obj[k] = PartnerOverride.fromProto(proto.partnerSpecificOverrides[k]);
        return obj;
      }, {});
    }
    if (proto.popularity) {
      m.popularity = parseInt(proto.popularity, 10);
    }
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    if (proto.syncRequirement) {
      m.syncRequirement = enumStringToValue$a(SyncRequirement, proto.syncRequirement);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.adminNotes !== 'undefined') {
      toReturn['adminNotes'] = this.adminNotes;
    }
    if (typeof this.createListingHtml !== 'undefined') {
      toReturn['createListingHtml'] = this.createListingHtml;
    }
    if (typeof this.createListingUrl !== 'undefined') {
      toReturn['createListingUrl'] = this.createListingUrl;
    }
    if (typeof this.claimListingHtml !== 'undefined') {
      toReturn['claimListingHtml'] = this.claimListingHtml;
    }
    if (typeof this.descriptionHtml !== 'undefined') {
      toReturn['descriptionHtml'] = this.descriptionHtml;
    }
    if (typeof this.domains !== 'undefined') {
      toReturn['domains'] = this.domains;
    }
    if (typeof this.editListingHtml !== 'undefined') {
      toReturn['editListingHtml'] = this.editListingHtml;
    }
    if (typeof this.editListingUrl !== 'undefined') {
      toReturn['editListingUrl'] = this.editListingUrl;
    }
    if (typeof this.enabledFlag !== 'undefined') {
      toReturn['enabledFlag'] = this.enabledFlag;
    }
    if (typeof this.hasListingsFlag !== 'undefined') {
      toReturn['hasListingsFlag'] = this.hasListingsFlag;
    }
    if (typeof this.hasNoRatingsReviewsFlag !== 'undefined') {
      toReturn['hasNoRatingsReviewsFlag'] = this.hasNoRatingsReviewsFlag;
    }
    if (typeof this.hasReviewsFlag !== 'undefined') {
      toReturn['hasReviewsFlag'] = this.hasReviewsFlag;
    }
    if (typeof this.hasListingReporting !== 'undefined') {
      toReturn['hasListingReporting'] = this.hasListingReporting;
    }
    if (typeof this.lspIcon !== 'undefined') {
      toReturn['lspIcon'] = this.lspIcon;
    }
    if (typeof this.iconClass16px !== 'undefined') {
      toReturn['iconClass16px'] = this.iconClass16px;
    }
    if (typeof this.iconClass32px !== 'undefined') {
      toReturn['iconClass32px'] = this.iconClass32px;
    }
    if (typeof this.iconClass50px !== 'undefined') {
      toReturn['iconClass50px'] = this.iconClass50px;
    }
    if (typeof this.iconUrl16px !== 'undefined') {
      toReturn['iconUrl16px'] = this.iconUrl16px;
    }
    if (typeof this.iconUrl32px !== 'undefined') {
      toReturn['iconUrl32px'] = this.iconUrl32px;
    }
    if (typeof this.iconUrl50px !== 'undefined') {
      toReturn['iconUrl50px'] = this.iconUrl50px;
    }
    if (typeof this.isDirectlySubmittedSource !== 'undefined') {
      toReturn['isDirectlySubmittedSource'] = this.isDirectlySubmittedSource;
    }
    if (typeof this.isLdSource !== 'undefined') {
      toReturn['isLdSource'] = this.isLdSource;
    }
    if (typeof this.isLocationWhitelistedByDefaultFlag !== 'undefined') {
      toReturn['isLocationWhitelistedByDefaultFlag'] = this.isLocationWhitelistedByDefaultFlag;
    }
    if (typeof this.isPartnerWhitelistedByDefaultFlag !== 'undefined') {
      toReturn['isPartnerWhitelistedByDefaultFlag'] = this.isPartnerWhitelistedByDefaultFlag;
    }
    if (typeof this.isTaxonomyWhitelistedByDefaultFlag !== 'undefined') {
      toReturn['isTaxonomyWhitelistedByDefaultFlag'] = this.isTaxonomyWhitelistedByDefaultFlag;
    }
    if (typeof this.ignoredAnchorDataMatches !== 'undefined') {
      toReturn['ignoredAnchorDataMatches'] = this.ignoredAnchorDataMatches;
    }
    if (typeof this.locationBlacklist !== 'undefined') {
      toReturn['locationBlacklist'] = this.locationBlacklist;
    }
    if (typeof this.locationSpecificOverrides !== 'undefined' && this.locationSpecificOverrides !== null) {
      toReturn['locationSpecificOverrides'] = 'toApiJson' in this.locationSpecificOverrides ? this.locationSpecificOverrides.toApiJson() : this.locationSpecificOverrides;
    }
    if (typeof this.locationWhitelist !== 'undefined') {
      toReturn['locationWhitelist'] = this.locationWhitelist;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.partnerBlacklist !== 'undefined') {
      toReturn['partnerBlacklist'] = this.partnerBlacklist;
    }
    if (typeof this.partnerSpecificOverrides !== 'undefined' && this.partnerSpecificOverrides !== null) {
      toReturn['partnerSpecificOverrides'] = 'toApiJson' in this.partnerSpecificOverrides ? this.partnerSpecificOverrides.toApiJson() : this.partnerSpecificOverrides;
    }
    if (typeof this.partnerWhitelist !== 'undefined') {
      toReturn['partnerWhitelist'] = this.partnerWhitelist;
    }
    if (typeof this.popularity !== 'undefined') {
      toReturn['popularity'] = this.popularity;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.sourceTypeId !== 'undefined') {
      toReturn['sourceTypeId'] = this.sourceTypeId;
    }
    if (typeof this.sourceTypeName !== 'undefined') {
      toReturn['sourceTypeName'] = this.sourceTypeName;
    }
    if (typeof this.submitListingHelpText !== 'undefined') {
      toReturn['submitListingHelpText'] = this.submitListingHelpText;
    }
    if (typeof this.submitListingValidationRegex !== 'undefined') {
      toReturn['submitListingValidationRegex'] = this.submitListingValidationRegex;
    }
    if (typeof this.supportsSubmittedListing !== 'undefined') {
      toReturn['supportsSubmittedListing'] = this.supportsSubmittedListing;
    }
    if (typeof this.taxonomyBlacklist !== 'undefined') {
      toReturn['taxonomyBlacklist'] = this.taxonomyBlacklist;
    }
    if (typeof this.taxonomyWhitelist !== 'undefined') {
      toReturn['taxonomyWhitelist'] = this.taxonomyWhitelist;
    }
    if (typeof this.uberallId !== 'undefined') {
      toReturn['uberallId'] = this.uberallId;
    }
    if (typeof this.yextId !== 'undefined') {
      toReturn['yextId'] = this.yextId;
    }
    if (typeof this.availableForServiceAreaBusiness !== 'undefined') {
      toReturn['availableForServiceAreaBusiness'] = this.availableForServiceAreaBusiness;
    }
    if (typeof this.syncRequirement !== 'undefined') {
      toReturn['syncRequirement'] = this.syncRequirement;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class GetPartnerSourcesResponseSourcesEntry {
  static fromProto(proto) {
    let m = new GetPartnerSourcesResponseSourcesEntry();
    m = Object.assign(m, proto);
    if (proto.key) {
      m.key = parseInt(proto.key, 10);
    }
    if (proto.value) {
      m.value = Source.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class UndeleteListingSourceRequest {
  static fromProto(proto) {
    let m = new UndeleteListingSourceRequest();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GoogleDate {
  static fromProto(proto) {
    let m = new GoogleDate();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.year !== 'undefined') {
      toReturn['year'] = this.year;
    }
    if (typeof this.month !== 'undefined') {
      toReturn['month'] = this.month;
    }
    if (typeof this.day !== 'undefined') {
      toReturn['day'] = this.day;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class TimeOfDay {
  static fromProto(proto) {
    let m = new TimeOfDay();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hours !== 'undefined') {
      toReturn['hours'] = this.hours;
    }
    if (typeof this.minutes !== 'undefined') {
      toReturn['minutes'] = this.minutes;
    }
    if (typeof this.seconds !== 'undefined') {
      toReturn['seconds'] = this.seconds;
    }
    if (typeof this.nanos !== 'undefined') {
      toReturn['nanos'] = this.nanos;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ActivateAccounts {
  static fromProto(proto) {
    let m = new ActivateAccounts();
    m = Object.assign(m, proto);
    if (proto.activations) {
      m.activations = proto.activations.map(Activation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activations !== 'undefined' && this.activations !== null) {
      toReturn['activations'] = 'toApiJson' in this.activations ? this.activations.toApiJson() : this.activations;
    }
    return toReturn;
  }
}
class Activation {
  static fromProto(proto) {
    let m = new Activation();
    m = Object.assign(m, proto);
    if (proto.appKey) {
      m.appKey = AppKey.fromProto(proto.appKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appKey !== 'undefined' && this.appKey !== null) {
      toReturn['appKey'] = 'toApiJson' in this.appKey ? this.appKey.toApiJson() : this.appKey;
    }
    if (typeof this.isTrial !== 'undefined') {
      toReturn['isTrial'] = this.isTrial;
    }
    return toReturn;
  }
}
class AppKey {
  static fromProto(proto) {
    let m = new AppKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class BingAttribute {
  static fromProto(proto) {
    let m = new BingAttribute();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class BingAttributeMetaData {
  static fromProto(proto) {
    let m = new BingAttributeMetaData();
    m = Object.assign(m, proto);
    if (proto.valueType) {
      m.valueType = enumStringToValue$7(ValueType, proto.valueType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.parent !== 'undefined') {
      toReturn['parent'] = this.parent;
    }
    if (typeof this.valueType !== 'undefined') {
      toReturn['valueType'] = this.valueType;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.repeatable !== 'undefined') {
      toReturn['repeatable'] = this.repeatable;
    }
    if (typeof this.valueDisplayNames !== 'undefined') {
      toReturn['valueDisplayNames'] = this.valueDisplayNames;
    }
    if (typeof this.values !== 'undefined') {
      toReturn['values'] = this.values;
    }
    return toReturn;
  }
}
class BingAttributeMetaDataList {
  static fromProto(proto) {
    let m = new BingAttributeMetaDataList();
    m = Object.assign(m, proto);
    if (proto.bingAttributeMetadata) {
      m.bingAttributeMetadata = proto.bingAttributeMetadata.map(BingAttributeMetaData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.bingAttributeMetadata !== 'undefined' && this.bingAttributeMetadata !== null) {
      toReturn['bingAttributeMetadata'] = 'toApiJson' in this.bingAttributeMetadata ? this.bingAttributeMetadata.toApiJson() : this.bingAttributeMetadata;
    }
    return toReturn;
  }
}
class BingAttributes {
  static fromProto(proto) {
    let m = new BingAttributes();
    m = Object.assign(m, proto);
    if (proto.bingAttribute) {
      m.bingAttribute = proto.bingAttribute.map(BingAttribute.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.bingAttribute !== 'undefined' && this.bingAttribute !== null) {
      toReturn['bingAttribute'] = 'toApiJson' in this.bingAttribute ? this.bingAttribute.toApiJson() : this.bingAttribute;
    }
    return toReturn;
  }
}
class BusinessHours {
  static fromProto(proto) {
    let m = new BusinessHours();
    m = Object.assign(m, proto);
    if (proto.regularHours) {
      m.regularHours = proto.regularHours.map(RegularHoursPeriod.fromProto);
    }
    if (proto.specialHours) {
      m.specialHours = proto.specialHours.map(SpecialHoursPeriod.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hoursTypeId !== 'undefined') {
      toReturn['hoursTypeId'] = this.hoursTypeId;
    }
    if (typeof this.regularHours !== 'undefined' && this.regularHours !== null) {
      toReturn['regularHours'] = 'toApiJson' in this.regularHours ? this.regularHours.toApiJson() : this.regularHours;
    }
    if (typeof this.specialHours !== 'undefined' && this.specialHours !== null) {
      toReturn['specialHours'] = 'toApiJson' in this.specialHours ? this.specialHours.toApiJson() : this.specialHours;
    }
    return toReturn;
  }
}
class CompetitorLocation {
  static fromProto(proto) {
    let m = new CompetitorLocation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.placeId !== 'undefined') {
      toReturn['placeId'] = this.placeId;
    }
    return toReturn;
  }
}
class ConditionalField {
  static fromProto(proto) {
    let m = new ConditionalField();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class CreateCompetitors {
  static fromProto(proto) {
    let m = new CreateCompetitors();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = proto.location.map(CompetitorLocation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    return toReturn;
  }
}
class CreateListingProfileRequest {
  static fromProto(proto) {
    let m = new CreateListingProfileRequest();
    m = Object.assign(m, proto);
    if (proto.nap) {
      m.nap = Location.fromProto(proto.nap);
    }
    if (proto.updateOperations) {
      m.updateOperations = proto.updateOperations.map(UpdateOperation.fromProto);
    }
    if (proto.createOperations) {
      m.createOperations = proto.createOperations.map(CreateOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nap !== 'undefined' && this.nap !== null) {
      toReturn['nap'] = 'toApiJson' in this.nap ? this.nap.toApiJson() : this.nap;
    }
    if (typeof this.businessLocationId !== 'undefined') {
      toReturn['businessLocationId'] = this.businessLocationId;
    }
    if (typeof this.updateOperations !== 'undefined' && this.updateOperations !== null) {
      toReturn['updateOperations'] = 'toApiJson' in this.updateOperations ? this.updateOperations.toApiJson() : this.updateOperations;
    }
    if (typeof this.createOperations !== 'undefined' && this.createOperations !== null) {
      toReturn['createOperations'] = 'toApiJson' in this.createOperations ? this.createOperations.toApiJson() : this.createOperations;
    }
    return toReturn;
  }
}
class CreateListingProfileResponse {
  static fromProto(proto) {
    let m = new CreateListingProfileResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class CreateOperation {
  static fromProto(proto) {
    let m = new CreateOperation();
    m = Object.assign(m, proto);
    if (proto.activateAccounts) {
      m.activateAccounts = ActivateAccounts.fromProto(proto.activateAccounts);
    }
    if (proto.createCompetitors) {
      m.createCompetitors = CreateCompetitors.fromProto(proto.createCompetitors);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activateAccounts !== 'undefined' && this.activateAccounts !== null) {
      toReturn['activateAccounts'] = 'toApiJson' in this.activateAccounts ? this.activateAccounts.toApiJson() : this.activateAccounts;
    }
    if (typeof this.createCompetitors !== 'undefined' && this.createCompetitors !== null) {
      toReturn['createCompetitors'] = 'toApiJson' in this.createCompetitors ? this.createCompetitors.toApiJson() : this.createCompetitors;
    }
    return toReturn;
  }
}
class DeleteListingProfileRequest {
  static fromProto(proto) {
    let m = new DeleteListingProfileRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class DoctorDotComCategory {
  static fromProto(proto) {
    let m = new DoctorDotComCategory();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.fullName !== 'undefined') {
      toReturn['fullName'] = this.fullName;
    }
    if (typeof this.nuccTaxonomyCode !== 'undefined') {
      toReturn['nuccTaxonomyCode'] = this.nuccTaxonomyCode;
    }
    return toReturn;
  }
}
class ExternalIdentifiers {
  static fromProto(proto) {
    let m = new ExternalIdentifiers();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.taxIds !== 'undefined') {
      toReturn['taxIds'] = this.taxIds;
    }
    if (typeof this.vCategoryIds !== 'undefined') {
      toReturn['vCategoryIds'] = this.vCategoryIds;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    if (typeof this.additionalSalesPersonIds !== 'undefined') {
      toReturn['additionalSalesPersonIds'] = this.additionalSalesPersonIds;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.customerIdentifier !== 'undefined') {
      toReturn['customerIdentifier'] = this.customerIdentifier;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.socialProfileId !== 'undefined') {
      toReturn['socialProfileId'] = this.socialProfileId;
    }
    if (typeof this.jobId !== 'undefined') {
      toReturn['jobId'] = this.jobId;
    }
    if (typeof this.actionLists !== 'undefined') {
      toReturn['actionLists'] = this.actionLists;
    }
    if (typeof this.updateOrigin !== 'undefined') {
      toReturn['updateOrigin'] = this.updateOrigin;
    }
    return toReturn;
  }
}
class Geo {
  static fromProto(proto) {
    let m = new Geo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.latitude !== 'undefined') {
      toReturn['latitude'] = this.latitude;
    }
    if (typeof this.longitude !== 'undefined') {
      toReturn['longitude'] = this.longitude;
    }
    return toReturn;
  }
}
class GetAttributeMetadataRequest {
  static fromProto(proto) {
    let m = new GetAttributeMetadataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.vendorId !== 'undefined') {
      toReturn['vendorId'] = this.vendorId;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    return toReturn;
  }
}
class GetAttributeMetadataResponse {
  static fromProto(proto) {
    let m = new GetAttributeMetadataResponse();
    m = Object.assign(m, proto);
    if (proto.attributeMedata) {
      m.attributeMedata = proto.attributeMedata.map(VendorAttributeMetaData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributeMedata !== 'undefined' && this.attributeMedata !== null) {
      toReturn['attributeMedata'] = 'toApiJson' in this.attributeMedata ? this.attributeMedata.toApiJson() : this.attributeMedata;
    }
    return toReturn;
  }
}
class GetMoreHoursTypesRequest {
  static fromProto(proto) {
    let m = new GetMoreHoursTypesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    return toReturn;
  }
}
class GetMoreHoursTypesResponse {
  static fromProto(proto) {
    let m = new GetMoreHoursTypesResponse();
    m = Object.assign(m, proto);
    if (proto.moreHoursTypes) {
      m.moreHoursTypes = proto.moreHoursTypes.map(MoreHoursType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.moreHoursTypes !== 'undefined' && this.moreHoursTypes !== null) {
      toReturn['moreHoursTypes'] = 'toApiJson' in this.moreHoursTypes ? this.moreHoursTypes.toApiJson() : this.moreHoursTypes;
    }
    return toReturn;
  }
}
class GetMultiListingProfileRequest {
  static fromProto(proto) {
    let m = new GetMultiListingProfileRequest();
    m = Object.assign(m, proto);
    if (proto.projectionFilter) {
      m.projectionFilter = ProjectionFilter.fromProto(proto.projectionFilter);
    }
    if (proto.readFilter) {
      m.readFilter = ReadFilter.fromProto(proto.readFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessIds !== 'undefined') {
      toReturn['businessIds'] = this.businessIds;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    if (typeof this.readFilter !== 'undefined' && this.readFilter !== null) {
      toReturn['readFilter'] = 'toApiJson' in this.readFilter ? this.readFilter.toApiJson() : this.readFilter;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    return toReturn;
  }
}
class GetMultiListingProfileResponse {
  static fromProto(proto) {
    let m = new GetMultiListingProfileResponse();
    m = Object.assign(m, proto);
    if (proto.listingProfiles) {
      m.listingProfiles = proto.listingProfiles.map(GetMultiListingProfileResponseListingProfileContainer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listingProfiles !== 'undefined' && this.listingProfiles !== null) {
      toReturn['listingProfiles'] = 'toApiJson' in this.listingProfiles ? this.listingProfiles.toApiJson() : this.listingProfiles;
    }
    return toReturn;
  }
}
class GoogleAttribute {
  static fromProto(proto) {
    let m = new GoogleAttribute();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class GoogleAttributeMetaData {
  static fromProto(proto) {
    let m = new GoogleAttributeMetaData();
    m = Object.assign(m, proto);
    if (proto.valueType) {
      m.valueType = enumStringToValue$7(ValueType, proto.valueType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.parent !== 'undefined') {
      toReturn['parent'] = this.parent;
    }
    if (typeof this.valueType !== 'undefined') {
      toReturn['valueType'] = this.valueType;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.repeatable !== 'undefined') {
      toReturn['repeatable'] = this.repeatable;
    }
    if (typeof this.valueDisplayNames !== 'undefined') {
      toReturn['valueDisplayNames'] = this.valueDisplayNames;
    }
    if (typeof this.values !== 'undefined') {
      toReturn['values'] = this.values;
    }
    return toReturn;
  }
}
class GoogleAttributeMetaDataList {
  static fromProto(proto) {
    let m = new GoogleAttributeMetaDataList();
    m = Object.assign(m, proto);
    if (proto.googleAttributeMetadata) {
      m.googleAttributeMetadata = proto.googleAttributeMetadata.map(GoogleAttributeMetaData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleAttributeMetadata !== 'undefined' && this.googleAttributeMetadata !== null) {
      toReturn['googleAttributeMetadata'] = 'toApiJson' in this.googleAttributeMetadata ? this.googleAttributeMetadata.toApiJson() : this.googleAttributeMetadata;
    }
    return toReturn;
  }
}
class GoogleAttributes {
  static fromProto(proto) {
    let m = new GoogleAttributes();
    m = Object.assign(m, proto);
    if (proto.googleAttribute) {
      m.googleAttribute = proto.googleAttribute.map(GoogleAttribute.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleAttribute !== 'undefined' && this.googleAttribute !== null) {
      toReturn['googleAttribute'] = 'toApiJson' in this.googleAttribute ? this.googleAttribute.toApiJson() : this.googleAttribute;
    }
    return toReturn;
  }
}
class GooglePlace {
  static fromProto(proto) {
    let m = new GooglePlace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.placeId !== 'undefined') {
      toReturn['placeId'] = this.placeId;
    }
    if (typeof this.placeName !== 'undefined') {
      toReturn['placeName'] = this.placeName;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    return toReturn;
  }
}
class HealthCareProfessionalInformation {
  static fromProto(proto) {
    let m = new HealthCareProfessionalInformation();
    m = Object.assign(m, proto);
    if (proto.dateOfBirth) {
      m.dateOfBirth = new Date(proto.dateOfBirth);
    }
    if (proto.gender) {
      m.gender = enumStringToValue$7(HealthCareProfessionalInformationGender, proto.gender);
    }
    if (proto.doctorDotComCategories) {
      m.doctorDotComCategories = proto.doctorDotComCategories.map(DoctorDotComCategory.fromProto);
    }
    if (proto.isProvider) {
      m.isProvider = enumStringToValue$7(HealthCareProfessionalInformationIsProvider, proto.isProvider);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dateOfBirth !== 'undefined' && this.dateOfBirth !== null) {
      toReturn['dateOfBirth'] = 'toApiJson' in this.dateOfBirth ? this.dateOfBirth.toApiJson() : this.dateOfBirth;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.fellowship !== 'undefined') {
      toReturn['fellowship'] = this.fellowship;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.gender !== 'undefined') {
      toReturn['gender'] = this.gender;
    }
    if (typeof this.initials !== 'undefined') {
      toReturn['initials'] = this.initials;
    }
    if (typeof this.insurancesAccepted !== 'undefined') {
      toReturn['insurancesAccepted'] = this.insurancesAccepted;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.medicalLicenseNumber !== 'undefined') {
      toReturn['medicalLicenseNumber'] = this.medicalLicenseNumber;
    }
    if (typeof this.nationalProviderIdentifier !== 'undefined') {
      toReturn['nationalProviderIdentifier'] = this.nationalProviderIdentifier;
    }
    if (typeof this.office !== 'undefined') {
      toReturn['office'] = this.office;
    }
    if (typeof this.professionalCredential !== 'undefined') {
      toReturn['professionalCredential'] = this.professionalCredential;
    }
    if (typeof this.residency !== 'undefined') {
      toReturn['residency'] = this.residency;
    }
    if (typeof this.school !== 'undefined') {
      toReturn['school'] = this.school;
    }
    if (typeof this.specialty !== 'undefined') {
      toReturn['specialty'] = this.specialty;
    }
    if (typeof this.standardizedTitle !== 'undefined') {
      toReturn['standardizedTitle'] = this.standardizedTitle;
    }
    if (typeof this.stateLicense !== 'undefined') {
      toReturn['stateLicense'] = this.stateLicense;
    }
    if (typeof this.isTakingPatients !== 'undefined') {
      toReturn['isTakingPatients'] = this.isTakingPatients;
    }
    if (typeof this.doctorDotComCategories !== 'undefined' && this.doctorDotComCategories !== null) {
      toReturn['doctorDotComCategories'] = 'toApiJson' in this.doctorDotComCategories ? this.doctorDotComCategories.toApiJson() : this.doctorDotComCategories;
    }
    if (typeof this.hospitalAffiliations !== 'undefined') {
      toReturn['hospitalAffiliations'] = this.hospitalAffiliations;
    }
    if (typeof this.isProvider !== 'undefined') {
      toReturn['isProvider'] = this.isProvider;
    }
    return toReturn;
  }
}
class HoursOfOperation {
  static fromProto(proto) {
    let m = new HoursOfOperation();
    m = Object.assign(m, proto);
    if (proto.hoursOfOperation) {
      m.hoursOfOperation = proto.hoursOfOperation.map(HoursOfOperationSpan.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hoursOfOperation !== 'undefined' && this.hoursOfOperation !== null) {
      toReturn['hoursOfOperation'] = 'toApiJson' in this.hoursOfOperation ? this.hoursOfOperation.toApiJson() : this.hoursOfOperation;
    }
    return toReturn;
  }
}
class LegacyAPICreateRequest {
  static fromProto(proto) {
    let m = new LegacyAPICreateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.args !== 'undefined') {
      toReturn['args'] = this.args;
    }
    return toReturn;
  }
}
class LegacyAPIUpdateRequest {
  static fromProto(proto) {
    let m = new LegacyAPIUpdateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.args !== 'undefined') {
      toReturn['args'] = this.args;
    }
    return toReturn;
  }
}
class LegacyProductDetails {
  static fromProto(proto) {
    let m = new LegacyProductDetails();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commonName !== 'undefined') {
      toReturn['commonName'] = this.commonName;
    }
    if (typeof this.adminNotes !== 'undefined') {
      toReturn['adminNotes'] = this.adminNotes;
    }
    if (typeof this.competitor !== 'undefined') {
      toReturn['competitor'] = this.competitor;
    }
    if (typeof this.shareOfVoiceService !== 'undefined') {
      toReturn['shareOfVoiceService'] = this.shareOfVoiceService;
    }
    return toReturn;
  }
}
class ListingProfile {
  static fromProto(proto) {
    let m = new ListingProfile();
    m = Object.assign(m, proto);
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.externalIdentifiers) {
      m.externalIdentifiers = ExternalIdentifiers.fromProto(proto.externalIdentifiers);
    }
    if (proto.socialUrls) {
      m.socialUrls = SocialURLs.fromProto(proto.socialUrls);
    }
    if (proto.hoursOfOperation) {
      m.hoursOfOperation = HoursOfOperation.fromProto(proto.hoursOfOperation);
    }
    if (proto.richData) {
      m.richData = RichData.fromProto(proto.richData);
    }
    if (proto.napData) {
      m.napData = Location.fromProto(proto.napData);
    }
    if (proto.businessHours) {
      m.businessHours = proto.businessHours.map(BusinessHours.fromProto);
    }
    if (proto.googleAttributes) {
      m.googleAttributes = proto.googleAttributes.map(GoogleAttribute.fromProto);
    }
    if (proto.googleAttributesMetadata) {
      m.googleAttributesMetadata = proto.googleAttributesMetadata.map(GoogleAttributeMetaData.fromProto);
    }
    if (proto.moreHoursTypes) {
      m.moreHoursTypes = proto.moreHoursTypes.map(MoreHoursType.fromProto);
    }
    if (proto.bingAttributes) {
      m.bingAttributes = proto.bingAttributes.map(BingAttribute.fromProto);
    }
    if (proto.bingAttributesMetadata) {
      m.bingAttributesMetadata = proto.bingAttributesMetadata.map(BingAttributeMetaData.fromProto);
    }
    if (proto.legacyProductDetails) {
      m.legacyProductDetails = LegacyProductDetails.fromProto(proto.legacyProductDetails);
    }
    if (proto.marketingInfo) {
      m.marketingInfo = MarketingInfo.fromProto(proto.marketingInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.externalIdentifiers !== 'undefined' && this.externalIdentifiers !== null) {
      toReturn['externalIdentifiers'] = 'toApiJson' in this.externalIdentifiers ? this.externalIdentifiers.toApiJson() : this.externalIdentifiers;
    }
    if (typeof this.socialUrls !== 'undefined' && this.socialUrls !== null) {
      toReturn['socialUrls'] = 'toApiJson' in this.socialUrls ? this.socialUrls.toApiJson() : this.socialUrls;
    }
    if (typeof this.hoursOfOperation !== 'undefined' && this.hoursOfOperation !== null) {
      toReturn['hoursOfOperation'] = 'toApiJson' in this.hoursOfOperation ? this.hoursOfOperation.toApiJson() : this.hoursOfOperation;
    }
    if (typeof this.richData !== 'undefined' && this.richData !== null) {
      toReturn['richData'] = 'toApiJson' in this.richData ? this.richData.toApiJson() : this.richData;
    }
    if (typeof this.napData !== 'undefined' && this.napData !== null) {
      toReturn['napData'] = 'toApiJson' in this.napData ? this.napData.toApiJson() : this.napData;
    }
    if (typeof this.businessHours !== 'undefined' && this.businessHours !== null) {
      toReturn['businessHours'] = 'toApiJson' in this.businessHours ? this.businessHours.toApiJson() : this.businessHours;
    }
    if (typeof this.googleAttributes !== 'undefined' && this.googleAttributes !== null) {
      toReturn['googleAttributes'] = 'toApiJson' in this.googleAttributes ? this.googleAttributes.toApiJson() : this.googleAttributes;
    }
    if (typeof this.googleAttributesMetadata !== 'undefined' && this.googleAttributesMetadata !== null) {
      toReturn['googleAttributesMetadata'] = 'toApiJson' in this.googleAttributesMetadata ? this.googleAttributesMetadata.toApiJson() : this.googleAttributesMetadata;
    }
    if (typeof this.moreHoursTypes !== 'undefined' && this.moreHoursTypes !== null) {
      toReturn['moreHoursTypes'] = 'toApiJson' in this.moreHoursTypes ? this.moreHoursTypes.toApiJson() : this.moreHoursTypes;
    }
    if (typeof this.bingAttributes !== 'undefined' && this.bingAttributes !== null) {
      toReturn['bingAttributes'] = 'toApiJson' in this.bingAttributes ? this.bingAttributes.toApiJson() : this.bingAttributes;
    }
    if (typeof this.bingAttributesMetadata !== 'undefined' && this.bingAttributesMetadata !== null) {
      toReturn['bingAttributesMetadata'] = 'toApiJson' in this.bingAttributesMetadata ? this.bingAttributesMetadata.toApiJson() : this.bingAttributesMetadata;
    }
    if (typeof this.legacyProductDetails !== 'undefined' && this.legacyProductDetails !== null) {
      toReturn['legacyProductDetails'] = 'toApiJson' in this.legacyProductDetails ? this.legacyProductDetails.toApiJson() : this.legacyProductDetails;
    }
    if (typeof this.marketingInfo !== 'undefined' && this.marketingInfo !== null) {
      toReturn['marketingInfo'] = 'toApiJson' in this.marketingInfo ? this.marketingInfo.toApiJson() : this.marketingInfo;
    }
    return toReturn;
  }
}
class GetMultiListingProfileResponseListingProfileContainer {
  static fromProto(proto) {
    let m = new GetMultiListingProfileResponseListingProfileContainer();
    m = Object.assign(m, proto);
    if (proto.listingProfile) {
      m.listingProfile = ListingProfile.fromProto(proto.listingProfile);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listingProfile !== 'undefined' && this.listingProfile !== null) {
      toReturn['listingProfile'] = 'toApiJson' in this.listingProfile ? this.listingProfile.toApiJson() : this.listingProfile;
    }
    return toReturn;
  }
}
class Location {
  static fromProto(proto) {
    let m = new Location();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = Geo.fromProto(proto.location);
    }
    if (proto.serviceArea) {
      m.serviceArea = ServiceArea.fromProto(proto.serviceArea);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.workNumber !== 'undefined') {
      toReturn['workNumber'] = this.workNumber;
    }
    if (typeof this.callTrackingNumber !== 'undefined') {
      toReturn['callTrackingNumber'] = this.callTrackingNumber;
    }
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    if (typeof this.timezone !== 'undefined') {
      toReturn['timezone'] = this.timezone;
    }
    if (typeof this.serviceAreaBusiness !== 'undefined') {
      toReturn['serviceAreaBusiness'] = this.serviceAreaBusiness;
    }
    if (typeof this.serviceArea !== 'undefined' && this.serviceArea !== null) {
      toReturn['serviceArea'] = 'toApiJson' in this.serviceArea ? this.serviceArea.toApiJson() : this.serviceArea;
    }
    return toReturn;
  }
}
class MarketingInfo {
  static fromProto(proto) {
    let m = new MarketingInfo();
    m = Object.assign(m, proto);
    if (proto.marketingClassification) {
      m.marketingClassification = enumStringToValue$7(MarketingClassification, proto.marketingClassification);
    }
    if (proto.lifecycleStage) {
      m.lifecycleStage = enumStringToValue$7(LifecycleStage, proto.lifecycleStage);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversionPoint !== 'undefined') {
      toReturn['conversionPoint'] = this.conversionPoint;
    }
    if (typeof this.marketingClassification !== 'undefined') {
      toReturn['marketingClassification'] = this.marketingClassification;
    }
    if (typeof this.lifecycleStage !== 'undefined') {
      toReturn['lifecycleStage'] = this.lifecycleStage;
    }
    return toReturn;
  }
}
class MoreHoursType {
  static fromProto(proto) {
    let m = new MoreHoursType();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hoursTypeId !== 'undefined') {
      toReturn['hoursTypeId'] = this.hoursTypeId;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.localizedDisplayName !== 'undefined') {
      toReturn['localizedDisplayName'] = this.localizedDisplayName;
    }
    return toReturn;
  }
}
class ProjectionFilter {
  static fromProto(proto) {
    let m = new ProjectionFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalIdentifiers !== 'undefined') {
      toReturn['externalIdentifiers'] = this.externalIdentifiers;
    }
    if (typeof this.socialUrls !== 'undefined') {
      toReturn['socialUrls'] = this.socialUrls;
    }
    if (typeof this.hoursOfOperation !== 'undefined') {
      toReturn['hoursOfOperation'] = this.hoursOfOperation;
    }
    if (typeof this.richData !== 'undefined') {
      toReturn['richData'] = this.richData;
    }
    if (typeof this.napData !== 'undefined') {
      toReturn['napData'] = this.napData;
    }
    if (typeof this.businessHours !== 'undefined') {
      toReturn['businessHours'] = this.businessHours;
    }
    if (typeof this.googleAttributes !== 'undefined') {
      toReturn['googleAttributes'] = this.googleAttributes;
    }
    if (typeof this.googleAttributesMetadata !== 'undefined') {
      toReturn['googleAttributesMetadata'] = this.googleAttributesMetadata;
    }
    if (typeof this.bingAttributes !== 'undefined') {
      toReturn['bingAttributes'] = this.bingAttributes;
    }
    if (typeof this.bingAttributesMetadata !== 'undefined') {
      toReturn['bingAttributesMetadata'] = this.bingAttributesMetadata;
    }
    if (typeof this.legacyProductDetails !== 'undefined') {
      toReturn['legacyProductDetails'] = this.legacyProductDetails;
    }
    return toReturn;
  }
}
class ReadFilter {
  static fromProto(proto) {
    let m = new ReadFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeDeleted !== 'undefined') {
      toReturn['includeDeleted'] = this.includeDeleted;
    }
    return toReturn;
  }
}
class RegularHoursPeriod {
  static fromProto(proto) {
    let m = new RegularHoursPeriod();
    m = Object.assign(m, proto);
    if (proto.openDay) {
      m.openDay = enumStringToValue$7(DayOfWeek, proto.openDay);
    }
    if (proto.openTime) {
      m.openTime = TimeOfDay.fromProto(proto.openTime);
    }
    if (proto.closeDay) {
      m.closeDay = enumStringToValue$7(DayOfWeek, proto.closeDay);
    }
    if (proto.closeTime) {
      m.closeTime = TimeOfDay.fromProto(proto.closeTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.openDay !== 'undefined') {
      toReturn['openDay'] = this.openDay;
    }
    if (typeof this.openTime !== 'undefined' && this.openTime !== null) {
      toReturn['openTime'] = 'toApiJson' in this.openTime ? this.openTime.toApiJson() : this.openTime;
    }
    if (typeof this.closeDay !== 'undefined') {
      toReturn['closeDay'] = this.closeDay;
    }
    if (typeof this.closeTime !== 'undefined' && this.closeTime !== null) {
      toReturn['closeTime'] = 'toApiJson' in this.closeTime ? this.closeTime.toApiJson() : this.closeTime;
    }
    return toReturn;
  }
}
class RichData {
  static fromProto(proto) {
    let m = new RichData();
    m = Object.assign(m, proto);
    if (proto.paymentMethods) {
      m.paymentMethods = proto.paymentMethods.map(v => enumStringToValue$7(RichDataPaymentMethods, v));
    }
    if (proto.healthCareProfessionalInformation) {
      m.healthCareProfessionalInformation = HealthCareProfessionalInformation.fromProto(proto.healthCareProfessionalInformation);
    }
    if (proto.serviceAvailability) {
      m.serviceAvailability = ServiceAvailability.fromProto(proto.serviceAvailability);
    }
    if (proto.conditionalFields) {
      m.conditionalFields = proto.conditionalFields.map(ConditionalField.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tollFreeNumber !== 'undefined') {
      toReturn['tollFreeNumber'] = this.tollFreeNumber;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.shortDescription !== 'undefined') {
      toReturn['shortDescription'] = this.shortDescription;
    }
    if (typeof this.servicesOffered !== 'undefined') {
      toReturn['servicesOffered'] = this.servicesOffered;
    }
    if (typeof this.brandsCarried !== 'undefined') {
      toReturn['brandsCarried'] = this.brandsCarried;
    }
    if (typeof this.landmark !== 'undefined') {
      toReturn['landmark'] = this.landmark;
    }
    if (typeof this.paymentMethods !== 'undefined') {
      toReturn['paymentMethods'] = this.paymentMethods;
    }
    if (typeof this.healthCareProfessionalInformation !== 'undefined' && this.healthCareProfessionalInformation !== null) {
      toReturn['healthCareProfessionalInformation'] = 'toApiJson' in this.healthCareProfessionalInformation ? this.healthCareProfessionalInformation.toApiJson() : this.healthCareProfessionalInformation;
    }
    if (typeof this.serviceAvailability !== 'undefined' && this.serviceAvailability !== null) {
      toReturn['serviceAvailability'] = 'toApiJson' in this.serviceAvailability ? this.serviceAvailability.toApiJson() : this.serviceAvailability;
    }
    if (typeof this.cellNumber !== 'undefined') {
      toReturn['cellNumber'] = this.cellNumber;
    }
    if (typeof this.faxNumber !== 'undefined') {
      toReturn['faxNumber'] = this.faxNumber;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.seoKeywords !== 'undefined') {
      toReturn['seoKeywords'] = this.seoKeywords;
    }
    if (typeof this.bookingUrl !== 'undefined') {
      toReturn['bookingUrl'] = this.bookingUrl;
    }
    if (typeof this.conditionalFields !== 'undefined' && this.conditionalFields !== null) {
      toReturn['conditionalFields'] = 'toApiJson' in this.conditionalFields ? this.conditionalFields.toApiJson() : this.conditionalFields;
    }
    if (typeof this.syncingSeoKeywords !== 'undefined') {
      toReturn['syncingSeoKeywords'] = this.syncingSeoKeywords;
    }
    if (typeof this.inferredAttributes !== 'undefined') {
      toReturn['inferredAttributes'] = this.inferredAttributes;
    }
    return toReturn;
  }
}
class ServiceArea {
  static fromProto(proto) {
    let m = new ServiceArea();
    m = Object.assign(m, proto);
    if (proto.businessType) {
      m.businessType = enumStringToValue$7(ServiceAreaBusinessType, proto.businessType);
    }
    if (proto.places) {
      m.places = proto.places.map(GooglePlace.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessType !== 'undefined') {
      toReturn['businessType'] = this.businessType;
    }
    if (typeof this.places !== 'undefined' && this.places !== null) {
      toReturn['places'] = 'toApiJson' in this.places ? this.places.toApiJson() : this.places;
    }
    return toReturn;
  }
}
class ServiceAvailability {
  static fromProto(proto) {
    let m = new ServiceAvailability();
    m = Object.assign(m, proto);
    if (proto.delivery) {
      m.delivery = enumStringToValue$7(IsAvailable, proto.delivery);
    }
    if (proto.noContactDelivery) {
      m.noContactDelivery = enumStringToValue$7(IsAvailable, proto.noContactDelivery);
    }
    if (proto.inStorePickup) {
      m.inStorePickup = enumStringToValue$7(IsAvailable, proto.inStorePickup);
    }
    if (proto.curbsidePickup) {
      m.curbsidePickup = enumStringToValue$7(IsAvailable, proto.curbsidePickup);
    }
    if (proto.appointmentsOnly) {
      m.appointmentsOnly = enumStringToValue$7(IsAvailable, proto.appointmentsOnly);
    }
    if (proto.ecommerceOnly) {
      m.ecommerceOnly = enumStringToValue$7(IsAvailable, proto.ecommerceOnly);
    }
    if (proto.closedStatus) {
      m.closedStatus = enumStringToValue$7(ClosedStatus, proto.closedStatus);
    }
    if (proto.closedStatusDate) {
      m.closedStatusDate = new Date(proto.closedStatusDate);
    }
    if (proto.reopeningDate) {
      m.reopeningDate = new Date(proto.reopeningDate);
    }
    if (proto.servesDineIn) {
      m.servesDineIn = enumStringToValue$7(IsAvailable, proto.servesDineIn);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.delivery !== 'undefined') {
      toReturn['delivery'] = this.delivery;
    }
    if (typeof this.noContactDelivery !== 'undefined') {
      toReturn['noContactDelivery'] = this.noContactDelivery;
    }
    if (typeof this.inStorePickup !== 'undefined') {
      toReturn['inStorePickup'] = this.inStorePickup;
    }
    if (typeof this.curbsidePickup !== 'undefined') {
      toReturn['curbsidePickup'] = this.curbsidePickup;
    }
    if (typeof this.appointmentsOnly !== 'undefined') {
      toReturn['appointmentsOnly'] = this.appointmentsOnly;
    }
    if (typeof this.ecommerceOnly !== 'undefined') {
      toReturn['ecommerceOnly'] = this.ecommerceOnly;
    }
    if (typeof this.closedStatus !== 'undefined') {
      toReturn['closedStatus'] = this.closedStatus;
    }
    if (typeof this.closedStatusDate !== 'undefined' && this.closedStatusDate !== null) {
      toReturn['closedStatusDate'] = 'toApiJson' in this.closedStatusDate ? this.closedStatusDate.toApiJson() : this.closedStatusDate;
    }
    if (typeof this.reopeningDate !== 'undefined' && this.reopeningDate !== null) {
      toReturn['reopeningDate'] = 'toApiJson' in this.reopeningDate ? this.reopeningDate.toApiJson() : this.reopeningDate;
    }
    if (typeof this.servesDineIn !== 'undefined') {
      toReturn['servesDineIn'] = this.servesDineIn;
    }
    return toReturn;
  }
}
class SocialURLs {
  static fromProto(proto) {
    let m = new SocialURLs();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleplusUrl !== 'undefined') {
      toReturn['googleplusUrl'] = this.googleplusUrl;
    }
    if (typeof this.linkedinUrl !== 'undefined') {
      toReturn['linkedinUrl'] = this.linkedinUrl;
    }
    if (typeof this.foursquareUrl !== 'undefined') {
      toReturn['foursquareUrl'] = this.foursquareUrl;
    }
    if (typeof this.twitterUrl !== 'undefined') {
      toReturn['twitterUrl'] = this.twitterUrl;
    }
    if (typeof this.facebookUrl !== 'undefined') {
      toReturn['facebookUrl'] = this.facebookUrl;
    }
    if (typeof this.rssUrl !== 'undefined') {
      toReturn['rssUrl'] = this.rssUrl;
    }
    if (typeof this.youtubeUrl !== 'undefined') {
      toReturn['youtubeUrl'] = this.youtubeUrl;
    }
    if (typeof this.instagramUrl !== 'undefined') {
      toReturn['instagramUrl'] = this.instagramUrl;
    }
    if (typeof this.pinterestUrl !== 'undefined') {
      toReturn['pinterestUrl'] = this.pinterestUrl;
    }
    return toReturn;
  }
}
class HoursOfOperationSpan {
  static fromProto(proto) {
    let m = new HoursOfOperationSpan();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dayOfWeek !== 'undefined') {
      toReturn['dayOfWeek'] = this.dayOfWeek;
    }
    if (typeof this.opens !== 'undefined') {
      toReturn['opens'] = this.opens;
    }
    if (typeof this.closes !== 'undefined') {
      toReturn['closes'] = this.closes;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class SpecialHoursPeriod {
  static fromProto(proto) {
    let m = new SpecialHoursPeriod();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$7(SpecialHoursStatus, proto.status);
    }
    if (proto.startDate) {
      m.startDate = GoogleDate.fromProto(proto.startDate);
    }
    if (proto.startTime) {
      m.startTime = TimeOfDay.fromProto(proto.startTime);
    }
    if (proto.endDate) {
      m.endDate = GoogleDate.fromProto(proto.endDate);
    }
    if (proto.endTime) {
      m.endTime = TimeOfDay.fromProto(proto.endTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.startTime !== 'undefined' && this.startTime !== null) {
      toReturn['startTime'] = 'toApiJson' in this.startTime ? this.startTime.toApiJson() : this.startTime;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    if (typeof this.endTime !== 'undefined' && this.endTime !== null) {
      toReturn['endTime'] = 'toApiJson' in this.endTime ? this.endTime.toApiJson() : this.endTime;
    }
    return toReturn;
  }
}
class UpdateListingProfileRequest {
  static fromProto(proto) {
    let m = new UpdateListingProfileRequest();
    m = Object.assign(m, proto);
    if (proto.updateOperations) {
      m.updateOperations = proto.updateOperations.map(UpdateOperation.fromProto);
    }
    if (proto.ifUnmodifiedSince) {
      m.ifUnmodifiedSince = new Date(proto.ifUnmodifiedSince);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.updateOperations !== 'undefined' && this.updateOperations !== null) {
      toReturn['updateOperations'] = 'toApiJson' in this.updateOperations ? this.updateOperations.toApiJson() : this.updateOperations;
    }
    if (typeof this.ifUnmodifiedSince !== 'undefined' && this.ifUnmodifiedSince !== null) {
      toReturn['ifUnmodifiedSince'] = 'toApiJson' in this.ifUnmodifiedSince ? this.ifUnmodifiedSince.toApiJson() : this.ifUnmodifiedSince;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    return toReturn;
  }
}
class UpdateOperation {
  static fromProto(proto) {
    let m = new UpdateOperation();
    m = Object.assign(m, proto);
    if (proto.nap) {
      m.nap = Location.fromProto(proto.nap);
    }
    if (proto.externalIdentifiers) {
      m.externalIdentifiers = ExternalIdentifiers.fromProto(proto.externalIdentifiers);
    }
    if (proto.socialUrls) {
      m.socialUrls = SocialURLs.fromProto(proto.socialUrls);
    }
    if (proto.hoursOfOperation) {
      m.hoursOfOperation = HoursOfOperation.fromProto(proto.hoursOfOperation);
    }
    if (proto.richData) {
      m.richData = RichData.fromProto(proto.richData);
    }
    if (proto.businessHours) {
      m.businessHours = BusinessHours.fromProto(proto.businessHours);
    }
    if (proto.googleAttributes) {
      m.googleAttributes = GoogleAttributes.fromProto(proto.googleAttributes);
    }
    if (proto.bingAttributes) {
      m.bingAttributes = BingAttributes.fromProto(proto.bingAttributes);
    }
    if (proto.legacyProductDetails) {
      m.legacyProductDetails = LegacyProductDetails.fromProto(proto.legacyProductDetails);
    }
    if (proto.marketingInfo) {
      m.marketingInfo = MarketingInfo.fromProto(proto.marketingInfo);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nap !== 'undefined' && this.nap !== null) {
      toReturn['nap'] = 'toApiJson' in this.nap ? this.nap.toApiJson() : this.nap;
    }
    if (typeof this.externalIdentifiers !== 'undefined' && this.externalIdentifiers !== null) {
      toReturn['externalIdentifiers'] = 'toApiJson' in this.externalIdentifiers ? this.externalIdentifiers.toApiJson() : this.externalIdentifiers;
    }
    if (typeof this.socialUrls !== 'undefined' && this.socialUrls !== null) {
      toReturn['socialUrls'] = 'toApiJson' in this.socialUrls ? this.socialUrls.toApiJson() : this.socialUrls;
    }
    if (typeof this.hoursOfOperation !== 'undefined' && this.hoursOfOperation !== null) {
      toReturn['hoursOfOperation'] = 'toApiJson' in this.hoursOfOperation ? this.hoursOfOperation.toApiJson() : this.hoursOfOperation;
    }
    if (typeof this.richData !== 'undefined' && this.richData !== null) {
      toReturn['richData'] = 'toApiJson' in this.richData ? this.richData.toApiJson() : this.richData;
    }
    if (typeof this.businessHours !== 'undefined' && this.businessHours !== null) {
      toReturn['businessHours'] = 'toApiJson' in this.businessHours ? this.businessHours.toApiJson() : this.businessHours;
    }
    if (typeof this.googleAttributes !== 'undefined' && this.googleAttributes !== null) {
      toReturn['googleAttributes'] = 'toApiJson' in this.googleAttributes ? this.googleAttributes.toApiJson() : this.googleAttributes;
    }
    if (typeof this.bingAttributes !== 'undefined' && this.bingAttributes !== null) {
      toReturn['bingAttributes'] = 'toApiJson' in this.bingAttributes ? this.bingAttributes.toApiJson() : this.bingAttributes;
    }
    if (typeof this.legacyProductDetails !== 'undefined' && this.legacyProductDetails !== null) {
      toReturn['legacyProductDetails'] = 'toApiJson' in this.legacyProductDetails ? this.legacyProductDetails.toApiJson() : this.legacyProductDetails;
    }
    if (typeof this.marketingInfo !== 'undefined' && this.marketingInfo !== null) {
      toReturn['marketingInfo'] = 'toApiJson' in this.marketingInfo ? this.marketingInfo.toApiJson() : this.marketingInfo;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class VendorAttributeMetaData {
  static fromProto(proto) {
    let m = new VendorAttributeMetaData();
    m = Object.assign(m, proto);
    if (proto.bingAttributeMetadata) {
      m.bingAttributeMetadata = BingAttributeMetaDataList.fromProto(proto.bingAttributeMetadata);
    }
    if (proto.googleAttributeMetadata) {
      m.googleAttributeMetadata = GoogleAttributeMetaDataList.fromProto(proto.googleAttributeMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorId !== 'undefined') {
      toReturn['vendorId'] = this.vendorId;
    }
    if (typeof this.bingAttributeMetadata !== 'undefined' && this.bingAttributeMetadata !== null) {
      toReturn['bingAttributeMetadata'] = 'toApiJson' in this.bingAttributeMetadata ? this.bingAttributeMetadata.toApiJson() : this.bingAttributeMetadata;
    }
    if (typeof this.googleAttributeMetadata !== 'undefined' && this.googleAttributeMetadata !== null) {
      toReturn['googleAttributeMetadata'] = 'toApiJson' in this.googleAttributeMetadata ? this.googleAttributeMetadata.toApiJson() : this.googleAttributeMetadata;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DeleteSuggestionRequest {
  static fromProto(proto) {
    let m = new DeleteSuggestionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetMultiSuggestionRequest {
  static fromProto(proto) {
    let m = new GetMultiSuggestionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessIds !== 'undefined') {
      toReturn['businessIds'] = this.businessIds;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.languageType !== 'undefined') {
      toReturn['languageType'] = this.languageType;
    }
    return toReturn;
  }
}
class GetMultiSuggestionResponse {
  static fromProto(proto) {
    let m = new GetMultiSuggestionResponse();
    m = Object.assign(m, proto);
    if (proto.suggestions) {
      m.suggestions = proto.suggestions.map(Suggestion.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.suggestions !== 'undefined' && this.suggestions !== null) {
      toReturn['suggestions'] = 'toApiJson' in this.suggestions ? this.suggestions.toApiJson() : this.suggestions;
    }
    return toReturn;
  }
}
class GetSuggestionRequest {
  static fromProto(proto) {
    let m = new GetSuggestionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    return toReturn;
  }
}
class GetSuggestionResponse {
  static fromProto(proto) {
    let m = new GetSuggestionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.suggestion !== 'undefined') {
      toReturn['suggestion'] = this.suggestion;
    }
    return toReturn;
  }
}
class ListSuggestionRequest {
  static fromProto(proto) {
    let m = new ListSuggestionRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListSuggestionResponse {
  static fromProto(proto) {
    let m = new ListSuggestionResponse();
    m = Object.assign(m, proto);
    if (proto.suggestions) {
      m.suggestions = proto.suggestions.map(Suggestion.fromProto);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.totalCount) {
      m.totalCount = parseInt(proto.totalCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.suggestions !== 'undefined' && this.suggestions !== null) {
      toReturn['suggestions'] = 'toApiJson' in this.suggestions ? this.suggestions.toApiJson() : this.suggestions;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.totalCount !== 'undefined') {
      toReturn['totalCount'] = this.totalCount;
    }
    return toReturn;
  }
}
class SuggestFieldUpdateRequest {
  static fromProto(proto) {
    let m = new SuggestFieldUpdateRequest();
    m = Object.assign(m, proto);
    if (proto.option) {
      m.option = enumStringToValue$6(UpdateOption, proto.option);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.existingValue !== 'undefined') {
      toReturn['existingValue'] = this.existingValue;
    }
    if (typeof this.option !== 'undefined') {
      toReturn['option'] = this.option;
    }
    if (typeof this.tone !== 'undefined') {
      toReturn['tone'] = this.tone;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    return toReturn;
  }
}
class SuggestFieldUpdateResponse {
  static fromProto(proto) {
    let m = new SuggestFieldUpdateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.suggestion !== 'undefined') {
      toReturn['suggestion'] = this.suggestion;
    }
    return toReturn;
  }
}
class Suggestion {
  static fromProto(proto) {
    let m = new Suggestion();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.suggestion !== 'undefined') {
      toReturn['suggestion'] = this.suggestion;
    }
    if (typeof this.primaryCategoryId !== 'undefined') {
      toReturn['primaryCategoryId'] = this.primaryCategoryId;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class UpsertSuggestionRequest {
  static fromProto(proto) {
    let m = new UpsertSuggestionRequest();
    m = Object.assign(m, proto);
    if (proto.updateOperations) {
      m.updateOperations = proto.updateOperations.map(UpdateOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.updateOperations !== 'undefined' && this.updateOperations !== null) {
      toReturn['updateOperations'] = 'toApiJson' in this.updateOperations ? this.updateOperations.toApiJson() : this.updateOperations;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddonActivation {
  static fromProto(proto) {
    let m = new AddonActivation();
    m = Object.assign(m, proto);
    if (proto.activated) {
      m.activated = new Date(proto.activated);
    }
    if (proto.deactivated) {
      m.deactivated = new Date(proto.deactivated);
    }
    if (proto.status) {
      m.status = enumStringToValue$5(AddonActivationAddonActivationStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.activated !== 'undefined' && this.activated !== null) {
      toReturn['activated'] = 'toApiJson' in this.activated ? this.activated.toApiJson() : this.activated;
    }
    if (typeof this.deactivated !== 'undefined' && this.deactivated !== null) {
      toReturn['deactivated'] = 'toApiJson' in this.deactivated ? this.deactivated.toApiJson() : this.deactivated;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.isTrial !== 'undefined') {
      toReturn['isTrial'] = this.isTrial;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}
class BusinessKeywords {
  static fromProto(proto) {
    let m = new BusinessKeywords();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.keywords !== 'undefined') {
      toReturn['keywords'] = this.keywords;
    }
    return toReturn;
  }
}
class GetActiveSEOAddonsRequest {
  static fromProto(proto) {
    let m = new GetActiveSEOAddonsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetActiveSEOAddonsResponse {
  static fromProto(proto) {
    let m = new GetActiveSEOAddonsResponse();
    m = Object.assign(m, proto);
    if (proto.activeAddons) {
      m.activeAddons = proto.activeAddons.map(AddonActivation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activeAddons !== 'undefined' && this.activeAddons !== null) {
      toReturn['activeAddons'] = 'toApiJson' in this.activeAddons ? this.activeAddons.toApiJson() : this.activeAddons;
    }
    return toReturn;
  }
}
class GetDataForSEOCategoryRequest {
  static fromProto(proto) {
    let m = new GetDataForSEOCategoryRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetDataForSEOCategoryResponse {
  static fromProto(proto) {
    let m = new GetDataForSEOCategoryResponse();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.primaryCategoryId !== 'undefined') {
      toReturn['primaryCategoryId'] = this.primaryCategoryId;
    }
    if (typeof this.categoryIds !== 'undefined') {
      toReturn['categoryIds'] = this.categoryIds;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.rawResponse !== 'undefined') {
      toReturn['rawResponse'] = this.rawResponse;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class GetLocalSearchSEODataRequest {
  static fromProto(proto) {
    let m = new GetLocalSearchSEODataRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.keyword !== 'undefined') {
      toReturn['keyword'] = this.keyword;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class GetLocalSearchSEODataResponse {
  static fromProto(proto) {
    let m = new GetLocalSearchSEODataResponse();
    m = Object.assign(m, proto);
    if (proto.localSearchData) {
      m.localSearchData = proto.localSearchData.map(LocalSearchData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keyword !== 'undefined') {
      toReturn['keyword'] = this.keyword;
    }
    if (typeof this.localSearchData !== 'undefined' && this.localSearchData !== null) {
      toReturn['localSearchData'] = 'toApiJson' in this.localSearchData ? this.localSearchData.toApiJson() : this.localSearchData;
    }
    return toReturn;
  }
}
class GetSEODataRequest {
  static fromProto(proto) {
    let m = new GetSEODataRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.keywords !== 'undefined') {
      toReturn['keywords'] = this.keywords;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class GetSEODataResponse {
  static fromProto(proto) {
    let m = new GetSEODataResponse();
    m = Object.assign(m, proto);
    if (proto.data) {
      m.data = proto.data.map(SEOData.fromProto);
    }
    if (proto.previousData) {
      m.previousData = proto.previousData.map(SEOData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.previousData !== 'undefined' && this.previousData !== null) {
      toReturn['previousData'] = 'toApiJson' in this.previousData ? this.previousData.toApiJson() : this.previousData;
    }
    return toReturn;
  }
}
class GetSEODataSummaryRequest {
  static fromProto(proto) {
    let m = new GetSEODataSummaryRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.keywords !== 'undefined') {
      toReturn['keywords'] = this.keywords;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class GetSEODataSummaryResponse {
  static fromProto(proto) {
    let m = new GetSEODataSummaryResponse();
    m = Object.assign(m, proto);
    if (proto.data) {
      m.data = proto.data.map(SEODataSummary.fromProto);
    }
    if (proto.previousData) {
      m.previousData = proto.previousData.map(SEODataSummary.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.previousData !== 'undefined' && this.previousData !== null) {
      toReturn['previousData'] = 'toApiJson' in this.previousData ? this.previousData.toApiJson() : this.previousData;
    }
    return toReturn;
  }
}
class GetSEOSettingsRequest {
  static fromProto(proto) {
    let m = new GetSEOSettingsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class LocalSearchData {
  static fromProto(proto) {
    let m = new LocalSearchData();
    m = Object.assign(m, proto);
    if (proto.vicinity) {
      m.vicinity = enumStringToValue$5(Vicinity, proto.vicinity);
    }
    if (proto.searchLocation) {
      m.searchLocation = Geo.fromProto(proto.searchLocation);
    }
    if (proto.results) {
      m.results = proto.results.map(LocalSearchResult.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keyword !== 'undefined') {
      toReturn['keyword'] = this.keyword;
    }
    if (typeof this.vicinity !== 'undefined') {
      toReturn['vicinity'] = this.vicinity;
    }
    if (typeof this.searchLocation !== 'undefined' && this.searchLocation !== null) {
      toReturn['searchLocation'] = 'toApiJson' in this.searchLocation ? this.searchLocation.toApiJson() : this.searchLocation;
    }
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? this.results.toApiJson() : this.results;
    }
    return toReturn;
  }
}
class LocalSearchResult {
  static fromProto(proto) {
    let m = new LocalSearchResult();
    m = Object.assign(m, proto);
    if (proto.reviews) {
      m.reviews = LocalSearchReviews.fromProto(proto.reviews);
    }
    if (proto.claimStatus) {
      m.claimStatus = enumStringToValue$5(GBPClaimStatus, proto.claimStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.rank !== 'undefined') {
      toReturn['rank'] = this.rank;
    }
    if (typeof this.isMainBusiness !== 'undefined') {
      toReturn['isMainBusiness'] = this.isMainBusiness;
    }
    if (typeof this.reviews !== 'undefined' && this.reviews !== null) {
      toReturn['reviews'] = 'toApiJson' in this.reviews ? this.reviews.toApiJson() : this.reviews;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.claimStatus !== 'undefined') {
      toReturn['claimStatus'] = this.claimStatus;
    }
    return toReturn;
  }
}
class LocalSearchReviews {
  static fromProto(proto) {
    let m = new LocalSearchReviews();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rating !== 'undefined') {
      toReturn['rating'] = this.rating;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}
class SEOData {
  static fromProto(proto) {
    let m = new SEOData();
    m = Object.assign(m, proto);
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.difficulty) {
      m.difficulty = parseInt(proto.difficulty, 10);
    }
    if (proto.searchVolume) {
      m.searchVolume = parseInt(proto.searchVolume, 10);
    }
    if (proto.localSearches) {
      m.localSearches = proto.localSearches.map(LocalSearchData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keyword !== 'undefined') {
      toReturn['keyword'] = this.keyword;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.localRank !== 'undefined') {
      toReturn['localRank'] = this.localRank;
    }
    if (typeof this.organicRank !== 'undefined') {
      toReturn['organicRank'] = this.organicRank;
    }
    if (typeof this.difficulty !== 'undefined') {
      toReturn['difficulty'] = this.difficulty;
    }
    if (typeof this.searchVolume !== 'undefined') {
      toReturn['searchVolume'] = this.searchVolume;
    }
    if (typeof this.localSearches !== 'undefined' && this.localSearches !== null) {
      toReturn['localSearches'] = 'toApiJson' in this.localSearches ? this.localSearches.toApiJson() : this.localSearches;
    }
    if (typeof this.searchRadius !== 'undefined') {
      toReturn['searchRadius'] = this.searchRadius;
    }
    if (typeof this.workflowUrl !== 'undefined') {
      toReturn['workflowUrl'] = this.workflowUrl;
    }
    return toReturn;
  }
}
class SEODataSummary {
  static fromProto(proto) {
    let m = new SEODataSummary();
    m = Object.assign(m, proto);
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.difficulty) {
      m.difficulty = parseInt(proto.difficulty, 10);
    }
    if (proto.searchVolume) {
      m.searchVolume = parseInt(proto.searchVolume, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keyword !== 'undefined') {
      toReturn['keyword'] = this.keyword;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.localRank !== 'undefined') {
      toReturn['localRank'] = this.localRank;
    }
    if (typeof this.organicRank !== 'undefined') {
      toReturn['organicRank'] = this.organicRank;
    }
    if (typeof this.difficulty !== 'undefined') {
      toReturn['difficulty'] = this.difficulty;
    }
    if (typeof this.searchVolume !== 'undefined') {
      toReturn['searchVolume'] = this.searchVolume;
    }
    if (typeof this.searchRadius !== 'undefined') {
      toReturn['searchRadius'] = this.searchRadius;
    }
    if (typeof this.workflowUrl !== 'undefined') {
      toReturn['workflowUrl'] = this.workflowUrl;
    }
    return toReturn;
  }
}
class SEOSettingsResponse {
  static fromProto(proto) {
    let m = new SEOSettingsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.localSearchRadius !== 'undefined') {
      toReturn['localSearchRadius'] = this.localSearchRadius;
    }
    if (typeof this.favoriteKeywords !== 'undefined') {
      toReturn['favoriteKeywords'] = this.favoriteKeywords;
    }
    if (typeof this.isFullSearchEnabled !== 'undefined') {
      toReturn['isFullSearchEnabled'] = this.isFullSearchEnabled;
    }
    return toReturn;
  }
}
class SaveSEOSettingsRequest {
  static fromProto(proto) {
    let m = new SaveSEOSettingsRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.localSearchRadius !== 'undefined') {
      toReturn['localSearchRadius'] = this.localSearchRadius;
    }
    if (typeof this.favoriteKeywords !== 'undefined') {
      toReturn['favoriteKeywords'] = this.favoriteKeywords;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.isFullSearchEnabled !== 'undefined') {
      toReturn['isFullSearchEnabled'] = this.isFullSearchEnabled;
    }
    return toReturn;
  }
}
class StartLocalSEODataWorkflowRequest {
  static fromProto(proto) {
    let m = new StartLocalSEODataWorkflowRequest();
    m = Object.assign(m, proto);
    if (proto.businesses) {
      m.businesses = proto.businesses.map(BusinessKeywords.fromProto);
    }
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businesses !== 'undefined' && this.businesses !== null) {
      toReturn['businesses'] = 'toApiJson' in this.businesses ? this.businesses.toApiJson() : this.businesses;
    }
    if (typeof this.forceSerpWorkflow !== 'undefined') {
      toReturn['forceSerpWorkflow'] = this.forceSerpWorkflow;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.forceKeywordInfoWorkflow !== 'undefined') {
      toReturn['forceKeywordInfoWorkflow'] = this.forceKeywordInfoWorkflow;
    }
    if (typeof this.forceSuggestedKeywordsWorkflow !== 'undefined') {
      toReturn['forceSuggestedKeywordsWorkflow'] = this.forceSuggestedKeywordsWorkflow;
    }
    if (typeof this.ignoreDataLakeResults !== 'undefined') {
      toReturn['ignoreDataLakeResults'] = this.ignoreDataLakeResults;
    }
    return toReturn;
  }
}
class StartSEOCategoryWorkflowRequest {
  static fromProto(proto) {
    let m = new StartSEOCategoryWorkflowRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessIds !== 'undefined') {
      toReturn['businessIds'] = this.businessIds;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Citation {
  static fromProto(proto) {
    let m = new Citation();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.matchedFields !== 'undefined') {
      toReturn['matchedFields'] = this.matchedFields;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.breadcrumb !== 'undefined') {
      toReturn['breadcrumb'] = this.breadcrumb;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class CitationsByDomain {
  static fromProto(proto) {
    let m = new CitationsByDomain();
    m = Object.assign(m, proto);
    if (proto.citations) {
      m.citations = proto.citations.map(Citation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.citations !== 'undefined' && this.citations !== null) {
      toReturn['citations'] = 'toApiJson' in this.citations ? this.citations.toApiJson() : this.citations;
    }
    return toReturn;
  }
}
class DeleteCitationsRequest {
  static fromProto(proto) {
    let m = new DeleteCitationsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.urls !== 'undefined') {
      toReturn['urls'] = this.urls;
    }
    return toReturn;
  }
}
class GetCitationDataRequest {
  static fromProto(proto) {
    let m = new GetCitationDataRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class GetCitationDataResponse {
  static fromProto(proto) {
    let m = new GetCitationDataResponse();
    m = Object.assign(m, proto);
    if (proto.citationCount) {
      m.citationCount = parseInt(proto.citationCount, 10);
    }
    if (proto.initialCitationCount) {
      m.initialCitationCount = parseInt(proto.initialCitationCount, 10);
    }
    if (proto.historicalCitationsSeries) {
      m.historicalCitationsSeries = proto.historicalCitationsSeries.map(HistoricalCitationsDataPoint.fromProto);
    }
    if (proto.citationsByDomain) {
      m.citationsByDomain = proto.citationsByDomain.map(CitationsByDomain.fromProto);
    }
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.citationPercentGrowth) {
      m.citationPercentGrowth = parseInt(proto.citationPercentGrowth, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.citationCount !== 'undefined') {
      toReturn['citationCount'] = this.citationCount;
    }
    if (typeof this.initialCitationCount !== 'undefined') {
      toReturn['initialCitationCount'] = this.initialCitationCount;
    }
    if (typeof this.historicalCitationsSeries !== 'undefined' && this.historicalCitationsSeries !== null) {
      toReturn['historicalCitationsSeries'] = 'toApiJson' in this.historicalCitationsSeries ? this.historicalCitationsSeries.toApiJson() : this.historicalCitationsSeries;
    }
    if (typeof this.citationsByDomain !== 'undefined' && this.citationsByDomain !== null) {
      toReturn['citationsByDomain'] = 'toApiJson' in this.citationsByDomain ? this.citationsByDomain.toApiJson() : this.citationsByDomain;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.citationPercentGrowth !== 'undefined') {
      toReturn['citationPercentGrowth'] = this.citationPercentGrowth;
    }
    return toReturn;
  }
}
class HistoricalCitationsDataPoint {
  static fromProto(proto) {
    let m = new HistoricalCitationsDataPoint();
    m = Object.assign(m, proto);
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class StartCitationWorkflowRequest {
  static fromProto(proto) {
    let m = new StartCitationWorkflowRequest();
    m = Object.assign(m, proto);
    if (proto.searchType) {
      m.searchType = parseInt(proto.searchType, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessIds !== 'undefined') {
      toReturn['businessIds'] = this.businessIds;
    }
    if (typeof this.searchType !== 'undefined') {
      toReturn['searchType'] = this.searchType;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Configuration {
  static fromProto(proto) {
    let m = new Configuration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.chatWidgetId !== 'undefined') {
      toReturn['chatWidgetId'] = this.chatWidgetId;
    }
    if (typeof this.publicMyListingUrl !== 'undefined') {
      toReturn['publicMyListingUrl'] = this.publicMyListingUrl;
    }
    return toReturn;
  }
}
class CreatePartnerSettingsRequest {
  static fromProto(proto) {
    let m = new CreatePartnerSettingsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.isSmbKeyWordEditingDisabled !== 'undefined') {
      toReturn['isSmbKeyWordEditingDisabled'] = this.isSmbKeyWordEditingDisabled;
    }
    if (typeof this.isFavoriteNewKeywordsDisabled !== 'undefined') {
      toReturn['isFavoriteNewKeywordsDisabled'] = this.isFavoriteNewKeywordsDisabled;
    }
    if (typeof this.isSyncKeywordsDisabled !== 'undefined') {
      toReturn['isSyncKeywordsDisabled'] = this.isSyncKeywordsDisabled;
    }
    return toReturn;
  }
}
class GetConfigurationRequest {
  static fromProto(proto) {
    let m = new GetConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetConfigurationResponse {
  static fromProto(proto) {
    let m = new GetConfigurationResponse();
    m = Object.assign(m, proto);
    if (proto.configuration) {
      m.configuration = Configuration.fromProto(proto.configuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    return toReturn;
  }
}
class GetPartnerSettingsRequest {
  static fromProto(proto) {
    let m = new GetPartnerSettingsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetPartnerSettingsResponse {
  static fromProto(proto) {
    let m = new GetPartnerSettingsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.isSmbKeyWordEditingDisabled !== 'undefined') {
      toReturn['isSmbKeyWordEditingDisabled'] = this.isSmbKeyWordEditingDisabled;
    }
    if (typeof this.isFavoriteNewKeywordsDisabled !== 'undefined') {
      toReturn['isFavoriteNewKeywordsDisabled'] = this.isFavoriteNewKeywordsDisabled;
    }
    if (typeof this.isSyncKeywordsDisabled !== 'undefined') {
      toReturn['isSyncKeywordsDisabled'] = this.isSyncKeywordsDisabled;
    }
    return toReturn;
  }
}
class UpsertPartnerSettingsRequest {
  static fromProto(proto) {
    let m = new UpsertPartnerSettingsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.isSmbKeyWordEditingDisabled !== 'undefined') {
      toReturn['isSmbKeyWordEditingDisabled'] = this.isSmbKeyWordEditingDisabled;
    }
    if (typeof this.isFavoriteNewKeywordsDisabled !== 'undefined') {
      toReturn['isFavoriteNewKeywordsDisabled'] = this.isFavoriteNewKeywordsDisabled;
    }
    if (typeof this.isSyncKeywordsDisabled !== 'undefined') {
      toReturn['isSyncKeywordsDisabled'] = this.isSyncKeywordsDisabled;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetOrGenerateSEOSuggestedKeywordsRequest {
  static fromProto(proto) {
    let m = new GetOrGenerateSEOSuggestedKeywordsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetOrGenerateSEOSuggestedKeywordsResponse {
  static fromProto(proto) {
    let m = new GetOrGenerateSEOSuggestedKeywordsResponse();
    m = Object.assign(m, proto);
    if (proto.keywordInfo) {
      m.keywordInfo = proto.keywordInfo.map(KeywordInfo.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.keywordInfo !== 'undefined' && this.keywordInfo !== null) {
      toReturn['keywordInfo'] = 'toApiJson' in this.keywordInfo ? this.keywordInfo.toApiJson() : this.keywordInfo;
    }
    return toReturn;
  }
}
class GetSEOSuggestedKeywordsRequest {
  static fromProto(proto) {
    let m = new GetSEOSuggestedKeywordsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetSEOSuggestedKeywordsResponse {
  static fromProto(proto) {
    let m = new GetSEOSuggestedKeywordsResponse();
    m = Object.assign(m, proto);
    if (proto.keywordInfo) {
      m.keywordInfo = proto.keywordInfo.map(KeywordInfo.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.keywordInfo !== 'undefined' && this.keywordInfo !== null) {
      toReturn['keywordInfo'] = 'toApiJson' in this.keywordInfo ? this.keywordInfo.toApiJson() : this.keywordInfo;
    }
    return toReturn;
  }
}
class KeywordInfo {
  static fromProto(proto) {
    let m = new KeywordInfo();
    m = Object.assign(m, proto);
    if (proto.competitionIndex) {
      m.competitionIndex = parseInt(proto.competitionIndex, 10);
    }
    if (proto.searchVolume) {
      m.searchVolume = parseInt(proto.searchVolume, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keyword !== 'undefined') {
      toReturn['keyword'] = this.keyword;
    }
    if (typeof this.competition !== 'undefined') {
      toReturn['competition'] = this.competition;
    }
    if (typeof this.competitionIndex !== 'undefined') {
      toReturn['competitionIndex'] = this.competitionIndex;
    }
    if (typeof this.searchVolume !== 'undefined') {
      toReturn['searchVolume'] = this.searchVolume;
    }
    if (typeof this.lowTopOfPageBid !== 'undefined') {
      toReturn['lowTopOfPageBid'] = this.lowTopOfPageBid;
    }
    if (typeof this.highTopOfPageBid !== 'undefined') {
      toReturn['highTopOfPageBid'] = this.highTopOfPageBid;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ConnectedDirectSyncAccount {
  static fromProto(proto) {
    let m = new ConnectedDirectSyncAccount();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    if (typeof this.isAuthenticated !== 'undefined') {
      toReturn['isAuthenticated'] = this.isAuthenticated;
    }
    if (typeof this.profileUrl !== 'undefined') {
      toReturn['profileUrl'] = this.profileUrl;
    }
    if (typeof this.profileImageUrl !== 'undefined') {
      toReturn['profileImageUrl'] = this.profileImageUrl;
    }
    if (typeof this.accountType !== 'undefined') {
      toReturn['accountType'] = this.accountType;
    }
    if (typeof this.clientTags !== 'undefined') {
      toReturn['clientTags'] = this.clientTags;
    }
    if (typeof this.isSyncingEnabled !== 'undefined') {
      toReturn['isSyncingEnabled'] = this.isSyncingEnabled;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.disabledFlag !== 'undefined') {
      toReturn['disabledFlag'] = this.disabledFlag;
    }
    if (typeof this.tokenBroken !== 'undefined') {
      toReturn['tokenBroken'] = this.tokenBroken;
    }
    if (typeof this.isVerified !== 'undefined') {
      toReturn['isVerified'] = this.isVerified;
    }
    return toReturn;
  }
}
class DetailedSyndicationStatusResultValue {
  static fromProto(proto) {
    let m = new DetailedSyndicationStatusResultValue();
    m = Object.assign(m, proto);
    if (proto.lastSyncTime) {
      m.lastSyncTime = new Date(proto.lastSyncTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dataType !== 'undefined') {
      toReturn['dataType'] = this.dataType;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.syncedFields !== 'undefined') {
      toReturn['syncedFields'] = this.syncedFields;
    }
    if (typeof this.failedFields !== 'undefined') {
      toReturn['failedFields'] = this.failedFields;
    }
    if (typeof this.lastSyncTime !== 'undefined' && this.lastSyncTime !== null) {
      toReturn['lastSyncTime'] = 'toApiJson' in this.lastSyncTime ? this.lastSyncTime.toApiJson() : this.lastSyncTime;
    }
    if (typeof this.errorMessage !== 'undefined') {
      toReturn['errorMessage'] = this.errorMessage;
    }
    return toReturn;
  }
}
class DetailedSyndicationStatusResults {
  static fromProto(proto) {
    let m = new DetailedSyndicationStatusResults();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = DetailedSyndicationStatusResultValue.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class EcosystemSource {
  static fromProto(proto) {
    let m = new EcosystemSource();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    return toReturn;
  }
}
class GetSyncDataRequest {
  static fromProto(proto) {
    let m = new GetSyncDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.refresh !== 'undefined') {
      toReturn['refresh'] = this.refresh;
    }
    if (typeof this.includeHidden !== 'undefined') {
      toReturn['includeHidden'] = this.includeHidden;
    }
    if (typeof this.sourceIds !== 'undefined') {
      toReturn['sourceIds'] = this.sourceIds;
    }
    return toReturn;
  }
}
class GetSyncDataResponse {
  static fromProto(proto) {
    let m = new GetSyncDataResponse();
    m = Object.assign(m, proto);
    if (proto.sources) {
      m.sources = proto.sources.map(SyncData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sources !== 'undefined' && this.sources !== null) {
      toReturn['sources'] = 'toApiJson' in this.sources ? this.sources.toApiJson() : this.sources;
    }
    return toReturn;
  }
}
class Metadata {
  static fromProto(proto) {
    let m = new Metadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class SyncData {
  static fromProto(proto) {
    let m = new SyncData();
    m = Object.assign(m, proto);
    if (proto.account) {
      m.account = ConnectedDirectSyncAccount.fromProto(proto.account);
    }
    if (proto.accuracy) {
      m.accuracy = SourceAccuracy.fromProto(proto.accuracy);
    }
    if (proto.score) {
      m.score = parseInt(proto.score, 10);
    }
    if (proto.maxScore) {
      m.maxScore = parseInt(proto.maxScore, 10);
    }
    if (proto.syncDetails) {
      m.syncDetails = SyndicationStatus.fromProto(proto.syncDetails);
    }
    if (proto.additionalAccounts) {
      m.additionalAccounts = proto.additionalAccounts.map(ConnectedDirectSyncAccount.fromProto);
    }
    if (proto.requirement) {
      m.requirement = enumStringToValue$1(SyncRequirement, proto.requirement);
    }
    if (proto.syncStatus) {
      m.syncStatus = enumStringToValue$1(SyncStatus, proto.syncStatus);
    }
    if (proto.provider) {
      m.provider = enumStringToValue$1(Provider, proto.provider);
    }
    if (proto.ecosystemSources) {
      m.ecosystemSources = proto.ecosystemSources.map(EcosystemSource.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    if (typeof this.account !== 'undefined' && this.account !== null) {
      toReturn['account'] = 'toApiJson' in this.account ? this.account.toApiJson() : this.account;
    }
    if (typeof this.connectLink !== 'undefined') {
      toReturn['connectLink'] = this.connectLink;
    }
    if (typeof this.accuracy !== 'undefined' && this.accuracy !== null) {
      toReturn['accuracy'] = 'toApiJson' in this.accuracy ? this.accuracy.toApiJson() : this.accuracy;
    }
    if (typeof this.score !== 'undefined') {
      toReturn['score'] = this.score;
    }
    if (typeof this.maxScore !== 'undefined') {
      toReturn['maxScore'] = this.maxScore;
    }
    if (typeof this.listingUrl !== 'undefined') {
      toReturn['listingUrl'] = this.listingUrl;
    }
    if (typeof this.listingId !== 'undefined') {
      toReturn['listingId'] = this.listingId;
    }
    if (typeof this.syncDetails !== 'undefined' && this.syncDetails !== null) {
      toReturn['syncDetails'] = 'toApiJson' in this.syncDetails ? this.syncDetails.toApiJson() : this.syncDetails;
    }
    if (typeof this.additionalAccounts !== 'undefined' && this.additionalAccounts !== null) {
      toReturn['additionalAccounts'] = 'toApiJson' in this.additionalAccounts ? this.additionalAccounts.toApiJson() : this.additionalAccounts;
    }
    if (typeof this.isSyncingEnabled !== 'undefined') {
      toReturn['isSyncingEnabled'] = this.isSyncingEnabled;
    }
    if (typeof this.isListingVerified !== 'undefined') {
      toReturn['isListingVerified'] = this.isListingVerified;
    }
    if (typeof this.hidden !== 'undefined') {
      toReturn['hidden'] = this.hidden;
    }
    if (typeof this.hiddenReason !== 'undefined') {
      toReturn['hiddenReason'] = this.hiddenReason;
    }
    if (typeof this.locked !== 'undefined') {
      toReturn['locked'] = this.locked;
    }
    if (typeof this.requirement !== 'undefined') {
      toReturn['requirement'] = this.requirement;
    }
    if (typeof this.syncStatus !== 'undefined') {
      toReturn['syncStatus'] = this.syncStatus;
    }
    if (typeof this.sourceType !== 'undefined') {
      toReturn['sourceType'] = this.sourceType;
    }
    if (typeof this.provider !== 'undefined') {
      toReturn['provider'] = this.provider;
    }
    if (typeof this.ecosystemSources !== 'undefined' && this.ecosystemSources !== null) {
      toReturn['ecosystemSources'] = 'toApiJson' in this.ecosystemSources ? this.ecosystemSources.toApiJson() : this.ecosystemSources;
    }
    return toReturn;
  }
}
class SyndicationStatus {
  static fromProto(proto) {
    let m = new SyndicationStatus();
    m = Object.assign(m, proto);
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.lastAttemptedOn) {
      m.lastAttemptedOn = new Date(proto.lastAttemptedOn);
    }
    if (proto.lastSucceededOn) {
      m.lastSucceededOn = new Date(proto.lastSucceededOn);
    }
    if (proto.detailedResults) {
      m.detailedResults = proto.detailedResults.map(DetailedSyndicationStatusResults.fromProto);
    }
    if (proto.metadata) {
      m.metadata = proto.metadata.map(Metadata.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.lastAttemptedOn !== 'undefined' && this.lastAttemptedOn !== null) {
      toReturn['lastAttemptedOn'] = 'toApiJson' in this.lastAttemptedOn ? this.lastAttemptedOn.toApiJson() : this.lastAttemptedOn;
    }
    if (typeof this.lastSucceededOn !== 'undefined' && this.lastSucceededOn !== null) {
      toReturn['lastSucceededOn'] = 'toApiJson' in this.lastSucceededOn ? this.lastSucceededOn.toApiJson() : this.lastSucceededOn;
    }
    if (typeof this.listingUrl !== 'undefined') {
      toReturn['listingUrl'] = this.listingUrl;
    }
    if (typeof this.listingExternalId !== 'undefined') {
      toReturn['listingExternalId'] = this.listingExternalId;
    }
    if (typeof this.lastSyncAttemptId !== 'undefined') {
      toReturn['lastSyncAttemptId'] = this.lastSyncAttemptId;
    }
    if (typeof this.lastSuccessfulAttemptId !== 'undefined') {
      toReturn['lastSuccessfulAttemptId'] = this.lastSuccessfulAttemptId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.detailedResults !== 'undefined' && this.detailedResults !== null) {
      toReturn['detailedResults'] = 'toApiJson' in this.detailedResults ? this.detailedResults.toApiJson() : this.detailedResults;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BulkConnectLocationsForGoogleUserRequest {
  static fromProto(proto) {
    let m = new BulkConnectLocationsForGoogleUserRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class BulkConnectLocationsForGoogleUserResponse {
  static fromProto(proto) {
    let m = new BulkConnectLocationsForGoogleUserResponse();
    m = Object.assign(m, proto);
    if (proto.connections) {
      m.connections = Object.keys(proto.connections).reduce((obj, k) => {
        obj[k] = proto.connections[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connections !== 'undefined' && this.connections !== null) {
      toReturn['connections'] = 'toApiJson' in this.connections ? this.connections.toApiJson() : this.connections;
    }
    if (typeof this.locationsNotConnected !== 'undefined') {
      toReturn['locationsNotConnected'] = this.locationsNotConnected;
    }
    return toReturn;
  }
}
class CheckSubmissionStatusRequest {
  static fromProto(proto) {
    let m = new CheckSubmissionStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class BulkConnectLocationsForGoogleUserResponseConnectionsEntry {
  static fromProto(proto) {
    let m = new BulkConnectLocationsForGoogleUserResponseConnectionsEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class CreateListingSourceRequest {
  static fromProto(proto) {
    let m = new CreateListingSourceRequest();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = Source.fromProto(proto.source);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.source !== 'undefined' && this.source !== null) {
      toReturn['source'] = 'toApiJson' in this.source ? this.source.toApiJson() : this.source;
    }
    return toReturn;
  }
}
class DirectSyncSource {
  static fromProto(proto) {
    let m = new DirectSyncSource();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    if (proto.account) {
      m.account = ConnectedDirectSyncAccount.fromProto(proto.account);
    }
    if (proto.accuracy) {
      m.accuracy = SourceAccuracy.fromProto(proto.accuracy);
    }
    if (proto.score) {
      m.score = parseInt(proto.score, 10);
    }
    if (proto.maxScore) {
      m.maxScore = parseInt(proto.maxScore, 10);
    }
    if (proto.syncStatus) {
      m.syncStatus = SyndicationStatus.fromProto(proto.syncStatus);
    }
    if (proto.additionalAccounts) {
      m.additionalAccounts = proto.additionalAccounts.map(ConnectedDirectSyncAccount.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.account !== 'undefined' && this.account !== null) {
      toReturn['account'] = 'toApiJson' in this.account ? this.account.toApiJson() : this.account;
    }
    if (typeof this.connectLink !== 'undefined') {
      toReturn['connectLink'] = this.connectLink;
    }
    if (typeof this.accuracy !== 'undefined' && this.accuracy !== null) {
      toReturn['accuracy'] = 'toApiJson' in this.accuracy ? this.accuracy.toApiJson() : this.accuracy;
    }
    if (typeof this.score !== 'undefined') {
      toReturn['score'] = this.score;
    }
    if (typeof this.maxScore !== 'undefined') {
      toReturn['maxScore'] = this.maxScore;
    }
    if (typeof this.listingUrl !== 'undefined') {
      toReturn['listingUrl'] = this.listingUrl;
    }
    if (typeof this.listingId !== 'undefined') {
      toReturn['listingId'] = this.listingId;
    }
    if (typeof this.syncStatus !== 'undefined' && this.syncStatus !== null) {
      toReturn['syncStatus'] = 'toApiJson' in this.syncStatus ? this.syncStatus.toApiJson() : this.syncStatus;
    }
    if (typeof this.additionalAccounts !== 'undefined' && this.additionalAccounts !== null) {
      toReturn['additionalAccounts'] = 'toApiJson' in this.additionalAccounts ? this.additionalAccounts.toApiJson() : this.additionalAccounts;
    }
    if (typeof this.isSyncingEnabled !== 'undefined') {
      toReturn['isSyncingEnabled'] = this.isSyncingEnabled;
    }
    if (typeof this.isListingVerified !== 'undefined') {
      toReturn['isListingVerified'] = this.isListingVerified;
    }
    if (typeof this.hidden !== 'undefined') {
      toReturn['hidden'] = this.hidden;
    }
    return toReturn;
  }
}
class FieldStatus {
  static fromProto(proto) {
    let m = new FieldStatus();
    m = Object.assign(m, proto);
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.updateOrigin !== 'undefined') {
      toReturn['updateOrigin'] = this.updateOrigin;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class GetAppleBusinessConnectInfoRequest {
  static fromProto(proto) {
    let m = new GetAppleBusinessConnectInfoRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetAppleBusinessConnectInfoResponse {
  static fromProto(proto) {
    let m = new GetAppleBusinessConnectInfoResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.textDump !== 'undefined') {
      toReturn['textDump'] = this.textDump;
    }
    return toReturn;
  }
}
class GetBingPlacesInfoRequest {
  static fromProto(proto) {
    let m = new GetBingPlacesInfoRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetBingPlacesInfoResponse {
  static fromProto(proto) {
    let m = new GetBingPlacesInfoResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.textDump !== 'undefined') {
      toReturn['textDump'] = this.textDump;
    }
    return toReturn;
  }
}
class GetBusinessProfileFieldStatusRequest {
  static fromProto(proto) {
    let m = new GetBusinessProfileFieldStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetBusinessProfileFieldStatusResponse {
  static fromProto(proto) {
    let m = new GetBusinessProfileFieldStatusResponse();
    m = Object.assign(m, proto);
    if (proto.companyName) {
      m.companyName = FieldStatus.fromProto(proto.companyName);
    }
    if (proto.address) {
      m.address = FieldStatus.fromProto(proto.address);
    }
    if (proto.address2) {
      m.address2 = FieldStatus.fromProto(proto.address2);
    }
    if (proto.city) {
      m.city = FieldStatus.fromProto(proto.city);
    }
    if (proto.state) {
      m.state = FieldStatus.fromProto(proto.state);
    }
    if (proto.zip) {
      m.zip = FieldStatus.fromProto(proto.zip);
    }
    if (proto.country) {
      m.country = FieldStatus.fromProto(proto.country);
    }
    if (proto.workNumber) {
      m.workNumber = FieldStatus.fromProto(proto.workNumber);
    }
    if (proto.callTrackingNumber) {
      m.callTrackingNumber = FieldStatus.fromProto(proto.callTrackingNumber);
    }
    if (proto.website) {
      m.website = FieldStatus.fromProto(proto.website);
    }
    if (proto.location) {
      m.location = FieldStatus.fromProto(proto.location);
    }
    if (proto.salesPersonId) {
      m.salesPersonId = FieldStatus.fromProto(proto.salesPersonId);
    }
    if (proto.additionalSalesPersonId) {
      m.additionalSalesPersonId = FieldStatus.fromProto(proto.additionalSalesPersonId);
    }
    if (proto.vcategoryIds) {
      m.vcategoryIds = FieldStatus.fromProto(proto.vcategoryIds);
    }
    if (proto.customerIdentifier) {
      m.customerIdentifier = FieldStatus.fromProto(proto.customerIdentifier);
    }
    if (proto.lifecycleStage) {
      m.lifecycleStage = FieldStatus.fromProto(proto.lifecycleStage);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.companyName !== 'undefined' && this.companyName !== null) {
      toReturn['companyName'] = 'toApiJson' in this.companyName ? this.companyName.toApiJson() : this.companyName;
    }
    if (typeof this.address !== 'undefined' && this.address !== null) {
      toReturn['address'] = 'toApiJson' in this.address ? this.address.toApiJson() : this.address;
    }
    if (typeof this.address2 !== 'undefined' && this.address2 !== null) {
      toReturn['address2'] = 'toApiJson' in this.address2 ? this.address2.toApiJson() : this.address2;
    }
    if (typeof this.city !== 'undefined' && this.city !== null) {
      toReturn['city'] = 'toApiJson' in this.city ? this.city.toApiJson() : this.city;
    }
    if (typeof this.state !== 'undefined' && this.state !== null) {
      toReturn['state'] = 'toApiJson' in this.state ? this.state.toApiJson() : this.state;
    }
    if (typeof this.zip !== 'undefined' && this.zip !== null) {
      toReturn['zip'] = 'toApiJson' in this.zip ? this.zip.toApiJson() : this.zip;
    }
    if (typeof this.country !== 'undefined' && this.country !== null) {
      toReturn['country'] = 'toApiJson' in this.country ? this.country.toApiJson() : this.country;
    }
    if (typeof this.workNumber !== 'undefined' && this.workNumber !== null) {
      toReturn['workNumber'] = 'toApiJson' in this.workNumber ? this.workNumber.toApiJson() : this.workNumber;
    }
    if (typeof this.callTrackingNumber !== 'undefined' && this.callTrackingNumber !== null) {
      toReturn['callTrackingNumber'] = 'toApiJson' in this.callTrackingNumber ? this.callTrackingNumber.toApiJson() : this.callTrackingNumber;
    }
    if (typeof this.website !== 'undefined' && this.website !== null) {
      toReturn['website'] = 'toApiJson' in this.website ? this.website.toApiJson() : this.website;
    }
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    if (typeof this.salesPersonId !== 'undefined' && this.salesPersonId !== null) {
      toReturn['salesPersonId'] = 'toApiJson' in this.salesPersonId ? this.salesPersonId.toApiJson() : this.salesPersonId;
    }
    if (typeof this.additionalSalesPersonId !== 'undefined' && this.additionalSalesPersonId !== null) {
      toReturn['additionalSalesPersonId'] = 'toApiJson' in this.additionalSalesPersonId ? this.additionalSalesPersonId.toApiJson() : this.additionalSalesPersonId;
    }
    if (typeof this.vcategoryIds !== 'undefined' && this.vcategoryIds !== null) {
      toReturn['vcategoryIds'] = 'toApiJson' in this.vcategoryIds ? this.vcategoryIds.toApiJson() : this.vcategoryIds;
    }
    if (typeof this.customerIdentifier !== 'undefined' && this.customerIdentifier !== null) {
      toReturn['customerIdentifier'] = 'toApiJson' in this.customerIdentifier ? this.customerIdentifier.toApiJson() : this.customerIdentifier;
    }
    if (typeof this.lifecycleStage !== 'undefined' && this.lifecycleStage !== null) {
      toReturn['lifecycleStage'] = 'toApiJson' in this.lifecycleStage ? this.lifecycleStage.toApiJson() : this.lifecycleStage;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class GetDirectSyncSourceInfoRequest {
  static fromProto(proto) {
    let m = new GetDirectSyncSourceInfoRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.refresh !== 'undefined') {
      toReturn['refresh'] = this.refresh;
    }
    return toReturn;
  }
}
class GetDirectSyncSourceInfoResponse {
  static fromProto(proto) {
    let m = new GetDirectSyncSourceInfoResponse();
    m = Object.assign(m, proto);
    if (proto.directSubmitSources) {
      m.directSubmitSources = proto.directSubmitSources.map(DirectSyncSource.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.directSubmitSources !== 'undefined' && this.directSubmitSources !== null) {
      toReturn['directSubmitSources'] = 'toApiJson' in this.directSubmitSources ? this.directSubmitSources.toApiJson() : this.directSubmitSources;
    }
    return toReturn;
  }
}
class GetDoctorDotComCategoriesRequest {
  static fromProto(proto) {
    let m = new GetDoctorDotComCategoriesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class GetDoctorDotComCategoriesResponse {
  static fromProto(proto) {
    let m = new GetDoctorDotComCategoriesResponse();
    m = Object.assign(m, proto);
    if (proto.categories) {
      m.categories = proto.categories.map(DoctorDotComCategory.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categories !== 'undefined' && this.categories !== null) {
      toReturn['categories'] = 'toApiJson' in this.categories ? this.categories.toApiJson() : this.categories;
    }
    return toReturn;
  }
}
class GetFacebookPageInfoRequest {
  static fromProto(proto) {
    let m = new GetFacebookPageInfoRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetFacebookPageInfoResponse {
  static fromProto(proto) {
    let m = new GetFacebookPageInfoResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.textDump !== 'undefined') {
      toReturn['textDump'] = this.textDump;
    }
    return toReturn;
  }
}
class GetGoogleBusinessInfoRequest {
  static fromProto(proto) {
    let m = new GetGoogleBusinessInfoRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetGoogleBusinessInfoResponse {
  static fromProto(proto) {
    let m = new GetGoogleBusinessInfoResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.textDump !== 'undefined') {
      toReturn['textDump'] = this.textDump;
    }
    return toReturn;
  }
}
class GetInfoGroupIdRequest {
  static fromProto(proto) {
    let m = new GetInfoGroupIdRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetInfoGroupIdResponse {
  static fromProto(proto) {
    let m = new GetInfoGroupIdResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.infogroupId !== 'undefined') {
      toReturn['infogroupId'] = this.infogroupId;
    }
    return toReturn;
  }
}
class GetLDDataRequest {
  static fromProto(proto) {
    let m = new GetLDDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetLDDataResponse {
  static fromProto(proto) {
    let m = new GetLDDataResponse();
    m = Object.assign(m, proto);
    if (proto.neustar) {
      m.neustar = DirectSyncSource.fromProto(proto.neustar);
    }
    if (proto.dataAxle) {
      m.dataAxle = DirectSyncSource.fromProto(proto.dataAxle);
    }
    if (proto.foursquare) {
      m.foursquare = DirectSyncSource.fromProto(proto.foursquare);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.neustar !== 'undefined' && this.neustar !== null) {
      toReturn['neustar'] = 'toApiJson' in this.neustar ? this.neustar.toApiJson() : this.neustar;
    }
    if (typeof this.dataAxle !== 'undefined' && this.dataAxle !== null) {
      toReturn['dataAxle'] = 'toApiJson' in this.dataAxle ? this.dataAxle.toApiJson() : this.dataAxle;
    }
    if (typeof this.foursquare !== 'undefined' && this.foursquare !== null) {
      toReturn['foursquare'] = 'toApiJson' in this.foursquare ? this.foursquare.toApiJson() : this.foursquare;
    }
    return toReturn;
  }
}
class GetListingDistributionActivationStatusRequest {
  static fromProto(proto) {
    let m = new GetListingDistributionActivationStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetListingDistributionActivationStatusResponse {
  static fromProto(proto) {
    let m = new GetListingDistributionActivationStatusResponse();
    m = Object.assign(m, proto);
    if (proto.activation) {
      m.activation = new Date(proto.activation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.isActive !== 'undefined') {
      toReturn['isActive'] = this.isActive;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.activation !== 'undefined' && this.activation !== null) {
      toReturn['activation'] = 'toApiJson' in this.activation ? this.activation.toApiJson() : this.activation;
    }
    return toReturn;
  }
}
class GetListingSourceByIdRequest {
  static fromProto(proto) {
    let m = new GetListingSourceByIdRequest();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    return toReturn;
  }
}
class GetListingSourceByIdResponse {
  static fromProto(proto) {
    let m = new GetListingSourceByIdResponse();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = Source.fromProto(proto.source);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.source !== 'undefined' && this.source !== null) {
      toReturn['source'] = 'toApiJson' in this.source ? this.source.toApiJson() : this.source;
    }
    return toReturn;
  }
}
class GetListingSourcesRequest {
  static fromProto(proto) {
    let m = new GetListingSourcesRequest();
    m = Object.assign(m, proto);
    if (proto.provider) {
      m.provider = enumStringToValue(Provider, proto.provider);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.provider !== 'undefined') {
      toReturn['provider'] = this.provider;
    }
    return toReturn;
  }
}
class GetListingSourcesResponse {
  static fromProto(proto) {
    let m = new GetListingSourcesResponse();
    m = Object.assign(m, proto);
    if (proto.sources) {
      m.sources = Object.keys(proto.sources).reduce((obj, k) => {
        obj[k] = Source.fromProto(proto.sources[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sources !== 'undefined' && this.sources !== null) {
      toReturn['sources'] = 'toApiJson' in this.sources ? this.sources.toApiJson() : this.sources;
    }
    return toReturn;
  }
}
class GetNeustarPublicationsRequest {
  static fromProto(proto) {
    let m = new GetNeustarPublicationsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetNeustarPublicationsResponse {
  static fromProto(proto) {
    let m = new GetNeustarPublicationsResponse();
    m = Object.assign(m, proto);
    if (proto.publications) {
      m.publications = proto.publications.map(NeustarPublication.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.publications !== 'undefined' && this.publications !== null) {
      toReturn['publications'] = 'toApiJson' in this.publications ? this.publications.toApiJson() : this.publications;
    }
    return toReturn;
  }
}
class GetProductSettingsRequest {
  static fromProto(proto) {
    let m = new GetProductSettingsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetProductSettingsResponse {
  static fromProto(proto) {
    let m = new GetProductSettingsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.canEditKeywords !== 'undefined') {
      toReturn['canEditKeywords'] = this.canEditKeywords;
    }
    return toReturn;
  }
}
class IsLocalSEOProActiveForAccountRequest {
  static fromProto(proto) {
    let m = new IsLocalSEOProActiveForAccountRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class IsLocalSEOProActiveForAccountResponse {
  static fromProto(proto) {
    let m = new IsLocalSEOProActiveForAccountResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.isActive !== 'undefined') {
      toReturn['isActive'] = this.isActive;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class IsPartnerUserRequest {
  static fromProto(proto) {
    let m = new IsPartnerUserRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class IsPartnerUserResponse {
  static fromProto(proto) {
    let m = new IsPartnerUserResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isPartnerUser !== 'undefined') {
      toReturn['isPartnerUser'] = this.isPartnerUser;
    }
    return toReturn;
  }
}
class ManuallyDeactivateUberallProvisioningRequest {
  static fromProto(proto) {
    let m = new ManuallyDeactivateUberallProvisioningRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ManuallyFixYextProvisioningRequest {
  static fromProto(proto) {
    let m = new ManuallyFixYextProvisioningRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    return toReturn;
  }
}
class ManuallyProvisionUberallRequest {
  static fromProto(proto) {
    let m = new ManuallyProvisionUberallRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    return toReturn;
  }
}
class NeustarPublication {
  static fromProto(proto) {
    let m = new NeustarPublication();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    if (proto.parentId) {
      m.parentId = parseInt(proto.parentId, 10);
    }
    if (proto.lastDeliveryTime) {
      m.lastDeliveryTime = new Date(proto.lastDeliveryTime);
    }
    if (proto.lastModified) {
      m.lastModified = new Date(proto.lastModified);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.parentId !== 'undefined') {
      toReturn['parentId'] = this.parentId;
    }
    if (typeof this.platform !== 'undefined') {
      toReturn['platform'] = this.platform;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.lastDeliveryTime !== 'undefined' && this.lastDeliveryTime !== null) {
      toReturn['lastDeliveryTime'] = 'toApiJson' in this.lastDeliveryTime ? this.lastDeliveryTime.toApiJson() : this.lastDeliveryTime;
    }
    if (typeof this.lastModified !== 'undefined' && this.lastModified !== null) {
      toReturn['lastModified'] = 'toApiJson' in this.lastModified ? this.lastModified.toApiJson() : this.lastModified;
    }
    if (typeof this.disposition !== 'undefined') {
      toReturn['disposition'] = this.disposition;
    }
    if (typeof this.link !== 'undefined') {
      toReturn['link'] = this.link;
    }
    return toReturn;
  }
}
class GetListingSourcesResponseSourcesEntry {
  static fromProto(proto) {
    let m = new GetListingSourcesResponseSourcesEntry();
    m = Object.assign(m, proto);
    if (proto.key) {
      m.key = parseInt(proto.key, 10);
    }
    if (proto.value) {
      m.value = Source.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class StartBusinessDataScoreWorkflowRequest {
  static fromProto(proto) {
    let m = new StartBusinessDataScoreWorkflowRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessIds !== 'undefined') {
      toReturn['businessIds'] = this.businessIds;
    }
    return toReturn;
  }
}
class SyncToSourcesRequest {
  static fromProto(proto) {
    let m = new SyncToSourcesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.trigger !== 'undefined') {
      toReturn['trigger'] = this.trigger;
    }
    return toReturn;
  }
}
class TriggerBingInsightsBackFillRequest {
  static fromProto(proto) {
    let m = new TriggerBingInsightsBackFillRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.firstSuccessfulSync !== 'undefined') {
      toReturn['firstSuccessfulSync'] = this.firstSuccessfulSync;
    }
    if (typeof this.startDate !== 'undefined') {
      toReturn['startDate'] = this.startDate;
    }
    if (typeof this.endDate !== 'undefined') {
      toReturn['endDate'] = this.endDate;
    }
    return toReturn;
  }
}
class UpdateListingSourceRequest {
  static fromProto(proto) {
    let m = new UpdateListingSourceRequest();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = Source.fromProto(proto.source);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.source !== 'undefined' && this.source !== null) {
      toReturn['source'] = 'toApiJson' in this.source ? this.source.toApiJson() : this.source;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateListingSourceResponse {
  static fromProto(proto) {
    let m = new UpdateListingSourceResponse();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = Source.fromProto(proto.source);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.source !== 'undefined' && this.source !== null) {
      toReturn['source'] = 'toApiJson' in this.source ? this.source.toApiJson() : this.source;
    }
    return toReturn;
  }
}
class UpdateVendorSyncFlagRequest {
  static fromProto(proto) {
    let m = new UpdateVendorSyncFlagRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.vendorId !== 'undefined') {
      toReturn['vendorId'] = this.vendorId;
    }
    if (typeof this.syncing !== 'undefined') {
      toReturn['syncing'] = this.syncing;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'listing-products-api.vendasta-local.com',
  'test': '',
  'demo': 'listing-products-api-demo.apigateway.co',
  'prod': 'listing-products-api-prod.apigateway.co',
  'production': 'listing-products-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CitationsApiService = /*#__PURE__*/(() => {
  class CitationsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    startCitationWorkflow(r) {
      const request = r.toApiJson ? r : new StartCitationWorkflowRequest(r);
      return this.http.post(this._host + "/listing_products.v1.Citations/StartCitationWorkflow", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getCitationData(r) {
      const request = r.toApiJson ? r : new GetCitationDataRequest(r);
      return this.http.post(this._host + "/listing_products.v1.Citations/GetCitationData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCitationDataResponse.fromProto(resp)));
    }
    deleteCitations(r) {
      const request = r.toApiJson ? r : new DeleteCitationsRequest(r);
      return this.http.post(this._host + "/listing_products.v1.Citations/DeleteCitations", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CitationsApiService.ɵfac = function CitationsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CitationsApiService)();
  };
  CitationsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CitationsApiService,
    factory: CitationsApiService.ɵfac,
    providedIn: 'root'
  });
  return CitationsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ListingProductsApiService = /*#__PURE__*/(() => {
  class ListingProductsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getGoogleMyBusinessInsightsData(r) {
      const request = r.toApiJson ? r : new GetGoogleMyBusinessInsightsDataRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetGoogleMyBusinessInsightsData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetGoogleMyBusinessInsightsDataResponse.fromProto(resp)));
    }
    getGoogleMyBusinessInsightsDataBucketed(r) {
      const request = r.toApiJson ? r : new GetGoogleMyBusinessInsightsDataBucketedRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetGoogleMyBusinessInsightsDataBucketed", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetGoogleMyBusinessInsightsDataBucketedResponse.fromProto(resp)));
    }
    updateVendorSyncFlag(r) {
      const request = r.toApiJson ? r : new UpdateVendorSyncFlagRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/UpdateVendorSyncFlag", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    submitTurboLister(r) {
      const request = r.toApiJson ? r : new SubmitTurboListerRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/SubmitTurboLister", request.toApiJson(), this.apiOptions()).pipe(map(resp => SubmitTurboListerResponse.fromProto(resp)));
    }
    getAddonAttributes(r) {
      const request = r.toApiJson ? r : new GetAddonAttributesRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetAddonAttributes", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAddonAttributesResponse.fromProto(resp)));
    }
    createAddonAttributes(r) {
      const request = r.toApiJson ? r : new CreateAddonAttributesRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/CreateAddonAttributes", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateAddonAttributes(r) {
      const request = r.toApiJson ? r : new UpdateAddonAttributesRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/UpdateAddonAttributes", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteAddonAttributes(r) {
      const request = r.toApiJson ? r : new DeleteAddonAttributesRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/DeleteAddonAttributes", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiAddonAttributes(r) {
      const request = r.toApiJson ? r : new GetMultiAddonAttributesRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetMultiAddonAttributes", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAddonAttributesResponse.fromProto(resp)));
    }
    bulkConnectLocationsForGoogleUser(r) {
      const request = r.toApiJson ? r : new BulkConnectLocationsForGoogleUserRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/BulkConnectLocationsForGoogleUser", request.toApiJson(), this.apiOptions()).pipe(map(resp => BulkConnectLocationsForGoogleUserResponse.fromProto(resp)));
    }
    manuallyFixYextProvisioning(r) {
      const request = r.toApiJson ? r : new ManuallyFixYextProvisioningRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/ManuallyFixYextProvisioning", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    manuallyProvisionUberall(r) {
      const request = r.toApiJson ? r : new ManuallyProvisionUberallRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/ManuallyProvisionUberall", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    manuallyDeactivateUberallProvisioning(r) {
      const request = r.toApiJson ? r : new ManuallyDeactivateUberallProvisioningRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/ManuallyDeactivateUberallProvisioning", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getGoogleBusinessInfo(r) {
      const request = r.toApiJson ? r : new GetGoogleBusinessInfoRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetGoogleBusinessInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetGoogleBusinessInfoResponse.fromProto(resp)));
    }
    getFacebookPageInfo(r) {
      const request = r.toApiJson ? r : new GetFacebookPageInfoRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetFacebookPageInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetFacebookPageInfoResponse.fromProto(resp)));
    }
    getAppleBusinessConnectInfo(r) {
      const request = r.toApiJson ? r : new GetAppleBusinessConnectInfoRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetAppleBusinessConnectInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAppleBusinessConnectInfoResponse.fromProto(resp)));
    }
    getBingPlacesInfo(r) {
      const request = r.toApiJson ? r : new GetBingPlacesInfoRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetBingPlacesInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBingPlacesInfoResponse.fromProto(resp)));
    }
    triggerBingInsightsBackFill(r) {
      const request = r.toApiJson ? r : new TriggerBingInsightsBackFillRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/TriggerBingInsightsBackFill", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    checkSubmissionStatus(r) {
      const request = r.toApiJson ? r : new CheckSubmissionStatusRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/CheckSubmissionStatus", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getInfoGroupId(r) {
      const request = r.toApiJson ? r : new GetInfoGroupIdRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetInfoGroupId", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetInfoGroupIdResponse.fromProto(resp)));
    }
    getListingDistributionActivationStatus(r) {
      const request = r.toApiJson ? r : new GetListingDistributionActivationStatusRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetListingDistributionActivationStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetListingDistributionActivationStatusResponse.fromProto(resp)));
    }
    getDirectSyncSourceInfo(r) {
      const request = r.toApiJson ? r : new GetDirectSyncSourceInfoRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetDirectSyncSourceInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDirectSyncSourceInfoResponse.fromProto(resp)));
    }
    getSyncData(r) {
      const request = r.toApiJson ? r : new GetSyncDataRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetSyncData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSyncDataResponse.fromProto(resp)));
    }
    getSyndicationInfo(r) {
      const request = r.toApiJson ? r : new GetSyndicationInfoRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetSyndicationInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSyndicationInfoResponse.fromProto(resp)));
    }
    getProductSettings(r) {
      const request = r.toApiJson ? r : new GetProductSettingsRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetProductSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetProductSettingsResponse.fromProto(resp)));
    }
    getDoctorDotComCategories(r) {
      const request = r.toApiJson ? r : new GetDoctorDotComCategoriesRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetDoctorDotComCategories", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDoctorDotComCategoriesResponse.fromProto(resp)));
    }
    fetchAndSubmitSourceUrLsToCs(r) {
      const request = r.toApiJson ? r : new FetchAndSubmitSourceURLsToCSRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/FetchAndSubmitSourceURLsToCS", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    startBusinessDataScoreWorkflow(r) {
      const request = r.toApiJson ? r : new StartBusinessDataScoreWorkflowRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/StartBusinessDataScoreWorkflow", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    isPartnerUser(r) {
      const request = r.toApiJson ? r : new IsPartnerUserRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/IsPartnerUser", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsPartnerUserResponse.fromProto(resp)));
    }
    isLocalSeoProActiveForAccount(r) {
      const request = r.toApiJson ? r : new IsLocalSEOProActiveForAccountRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/IsLocalSEOProActiveForAccount", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsLocalSEOProActiveForAccountResponse.fromProto(resp)));
    }
    getLdData(r) {
      const request = r.toApiJson ? r : new GetLDDataRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetLDData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLDDataResponse.fromProto(resp)));
    }
    syncToSources(r) {
      const request = r.toApiJson ? r : new SyncToSourcesRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/SyncToSources", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getNeustarPublications(r) {
      const request = r.toApiJson ? r : new GetNeustarPublicationsRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProductsService/GetNeustarPublications", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetNeustarPublicationsResponse.fromProto(resp)));
    }
  }
  ListingProductsApiService.ɵfac = function ListingProductsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListingProductsApiService)();
  };
  ListingProductsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ListingProductsApiService,
    factory: ListingProductsApiService.ɵfac,
    providedIn: 'root'
  });
  return ListingProductsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ListingProfileApiService = /*#__PURE__*/(() => {
  class ListingProfileApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateListingProfileRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProfileService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateListingProfileResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiListingProfileRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProfileService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiListingProfileResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateListingProfileRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProfileService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteListingProfileRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProfileService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMoreHoursTypes(r) {
      const request = r.toApiJson ? r : new GetMoreHoursTypesRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProfileService/GetMoreHoursTypes", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMoreHoursTypesResponse.fromProto(resp)));
    }
    getAttributeMetadata(r) {
      const request = r.toApiJson ? r : new GetAttributeMetadataRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProfileService/GetAttributeMetadata", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAttributeMetadataResponse.fromProto(resp)));
    }
    getDoctorDotComCategories(r) {
      const request = r.toApiJson ? r : new GetDoctorDotComCategoriesRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProfileService/GetDoctorDotComCategories", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDoctorDotComCategoriesResponse.fromProto(resp)));
    }
    legacyApiCreate(r) {
      const request = r.toApiJson ? r : new LegacyAPICreateRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProfileService/LegacyAPICreate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    legacyApiUpdate(r) {
      const request = r.toApiJson ? r : new LegacyAPIUpdateRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProfileService/LegacyAPIUpdate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getBusinessProfileFieldStatus(r) {
      const request = r.toApiJson ? r : new GetBusinessProfileFieldStatusRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingProfileService/GetBusinessProfileFieldStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBusinessProfileFieldStatusResponse.fromProto(resp)));
    }
  }
  ListingProfileApiService.ɵfac = function ListingProfileApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListingProfileApiService)();
  };
  ListingProfileApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ListingProfileApiService,
    factory: ListingProfileApiService.ɵfac,
    providedIn: 'root'
  });
  return ListingProfileApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ListingSourceApiService = /*#__PURE__*/(() => {
  class ListingSourceApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getListingSources(r) {
      const request = r.toApiJson ? r : new GetListingSourcesRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingSourceService/GetListingSources", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetListingSourcesResponse.fromProto(resp)));
    }
    getListingSourceById(r) {
      const request = r.toApiJson ? r : new GetListingSourceByIdRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingSourceService/GetListingSourceById", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetListingSourceByIdResponse.fromProto(resp)));
    }
    getListingSourceByProviderId(r) {
      const request = r.toApiJson ? r : new GetListingSourceByProviderIdRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingSourceService/GetListingSourceByProviderId", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetListingSourceByProviderIdResponse.fromProto(resp)));
    }
    getPartnerSources(r) {
      const request = r.toApiJson ? r : new GetPartnerSourcesRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingSourceService/GetPartnerSources", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPartnerSourcesResponse.fromProto(resp)));
    }
    createListingSource(r) {
      const request = r.toApiJson ? r : new CreateListingSourceRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingSourceService/CreateListingSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteListingSource(r) {
      const request = r.toApiJson ? r : new DeleteListingSourceRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingSourceService/DeleteListingSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    undeleteListingSource(r) {
      const request = r.toApiJson ? r : new UndeleteListingSourceRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingSourceService/UndeleteListingSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateListingSource(r) {
      const request = r.toApiJson ? r : new UpdateListingSourceRequest(r);
      return this.http.post(this._host + "/listing_products.v1.ListingSourceService/UpdateListingSource", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateListingSourceResponse.fromProto(resp)));
    }
  }
  ListingSourceApiService.ɵfac = function ListingSourceApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListingSourceApiService)();
  };
  ListingSourceApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ListingSourceApiService,
    factory: ListingSourceApiService.ɵfac,
    providedIn: 'root'
  });
  return ListingSourceApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PartnerSettingsApiService = /*#__PURE__*/(() => {
  class PartnerSettingsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createPartnerSettings(r) {
      const request = r.toApiJson ? r : new CreatePartnerSettingsRequest(r);
      return this.http.post(this._host + "/listing_products.v1.PartnerSettingsService/CreatePartnerSettings", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getPartnerSettings(r) {
      const request = r.toApiJson ? r : new GetPartnerSettingsRequest(r);
      return this.http.post(this._host + "/listing_products.v1.PartnerSettingsService/GetPartnerSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPartnerSettingsResponse.fromProto(resp)));
    }
    upsertPartnerSettings(r) {
      const request = r.toApiJson ? r : new UpsertPartnerSettingsRequest(r);
      return this.http.post(this._host + "/listing_products.v1.PartnerSettingsService/UpsertPartnerSettings", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getConfiguration(r) {
      const request = r.toApiJson ? r : new GetConfigurationRequest(r);
      return this.http.post(this._host + "/listing_products.v1.PartnerSettingsService/GetConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConfigurationResponse.fromProto(resp)));
    }
  }
  PartnerSettingsApiService.ɵfac = function PartnerSettingsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PartnerSettingsApiService)();
  };
  PartnerSettingsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerSettingsApiService,
    factory: PartnerSettingsApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerSettingsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SEOApiService = /*#__PURE__*/(() => {
  class SEOApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getSeoData(r) {
      const request = r.toApiJson ? r : new GetSEODataRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SEOService/GetSEOData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSEODataResponse.fromProto(resp)));
    }
    getSeoDataSummary(r) {
      const request = r.toApiJson ? r : new GetSEODataSummaryRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SEOService/GetSEODataSummary", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSEODataSummaryResponse.fromProto(resp)));
    }
    getLocalSearchSeoData(r) {
      const request = r.toApiJson ? r : new GetLocalSearchSEODataRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SEOService/GetLocalSearchSEOData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLocalSearchSEODataResponse.fromProto(resp)));
    }
    startLocalSeoDataWorkflow(r) {
      const request = r.toApiJson ? r : new StartLocalSEODataWorkflowRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SEOService/StartLocalSEODataWorkflow", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    saveSeoSettings(r) {
      const request = r.toApiJson ? r : new SaveSEOSettingsRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SEOService/SaveSEOSettings", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getSeoSettings(r) {
      const request = r.toApiJson ? r : new GetSEOSettingsRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SEOService/GetSEOSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => SEOSettingsResponse.fromProto(resp)));
    }
    getActiveSeoAddons(r) {
      const request = r.toApiJson ? r : new GetActiveSEOAddonsRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SEOService/GetActiveSEOAddons", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetActiveSEOAddonsResponse.fromProto(resp)));
    }
    startSeoCategoryWorkflow(r) {
      const request = r.toApiJson ? r : new StartSEOCategoryWorkflowRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SEOService/StartSEOCategoryWorkflow", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getDataForSeoCategory(r) {
      const request = r.toApiJson ? r : new GetDataForSEOCategoryRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SEOService/GetDataForSEOCategory", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDataForSEOCategoryResponse.fromProto(resp)));
    }
  }
  SEOApiService.ɵfac = function SEOApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SEOApiService)();
  };
  SEOApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SEOApiService,
    factory: SEOApiService.ɵfac,
    providedIn: 'root'
  });
  return SEOApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SEOSuggestedKeywordsApiService = /*#__PURE__*/(() => {
  class SEOSuggestedKeywordsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getOrGenerateSeoSuggestedKeywords(r) {
      const request = r.toApiJson ? r : new GetOrGenerateSEOSuggestedKeywordsRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SEOSuggestedKeywordsService/GetOrGenerateSEOSuggestedKeywords", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetOrGenerateSEOSuggestedKeywordsResponse.fromProto(resp)));
    }
    getSeoSuggestedKeywords(r) {
      const request = r.toApiJson ? r : new GetSEOSuggestedKeywordsRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SEOSuggestedKeywordsService/GetSEOSuggestedKeywords", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSEOSuggestedKeywordsResponse.fromProto(resp)));
    }
  }
  SEOSuggestedKeywordsApiService.ɵfac = function SEOSuggestedKeywordsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SEOSuggestedKeywordsApiService)();
  };
  SEOSuggestedKeywordsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SEOSuggestedKeywordsApiService,
    factory: SEOSuggestedKeywordsApiService.ɵfac,
    providedIn: 'root'
  });
  return SEOSuggestedKeywordsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SuggestionApiService = /*#__PURE__*/(() => {
  class SuggestionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    upsert(r) {
      const request = r.toApiJson ? r : new UpsertSuggestionRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SuggestionService/Upsert", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getSuggestion(r) {
      const request = r.toApiJson ? r : new GetSuggestionRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SuggestionService/GetSuggestion", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSuggestionResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiSuggestionRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SuggestionService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiSuggestionResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteSuggestionRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SuggestionService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new ListSuggestionRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SuggestionService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSuggestionResponse.fromProto(resp)));
    }
    suggestFieldUpdate(r) {
      const request = r.toApiJson ? r : new SuggestFieldUpdateRequest(r);
      return this.http.post(this._host + "/listing_products.v1.SuggestionService/SuggestFieldUpdate", request.toApiJson(), this.apiOptions()).pipe(map(resp => SuggestFieldUpdateResponse.fromProto(resp)));
    }
  }
  SuggestionApiService.ɵfac = function SuggestionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SuggestionApiService)();
  };
  SuggestionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SuggestionApiService,
    factory: SuggestionApiService.ɵfac,
    providedIn: 'root'
  });
  return SuggestionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let ListingProductsService = /*#__PURE__*/(() => {
  class ListingProductsService {
    constructor(_api) {
      this._api = _api;
    }
    getGoogleMyBusinessInsightsData(businessId, startDate, endDate) {
      return this._api.getGoogleMyBusinessInsightsData({
        businessId: businessId,
        startDate: startDate,
        endDate: endDate
      }).pipe(catchError(handleError));
    }
    getGoogleMyBusinessInsightsDataBucketed(businessId, startDate, endDate) {
      return this._api.getGoogleMyBusinessInsightsDataBucketed({
        businessId: businessId,
        startDate: startDate,
        endDate: endDate
      }).pipe(catchError(handleError));
    }
  }
  ListingProductsService.ɵfac = function ListingProductsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListingProductsService)(i0.ɵɵinject(ListingProductsApiService));
  };
  ListingProductsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ListingProductsService,
    factory: ListingProductsService.ɵfac,
    providedIn: "root"
  });
  return ListingProductsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function handleError(error) {
  if (error.error instanceof ErrorEvent) {
    console.error(`An error occurred:`, error.error.message);
  } else {
    console.error(`Server returned ${error.message}`);
  }
  return throwError(() => `Failed to talk to Listing Products microservice`);
}

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AccuracyStatus, ActivateAccounts, Activation, AddonActivation, AddonActivationAddonActivationStatus, AddonAttributes, AddonType, AnchorData, AnchorDataMatches, AppKey, BingAttribute, BingAttributeMetaData, BingAttributeMetaDataList, BingAttributes, BulkConnectLocationsForGoogleUserRequest, BulkConnectLocationsForGoogleUserResponse, BulkConnectLocationsForGoogleUserResponseConnectionsEntry, BusinessHours, BusinessKeywords, CheckSubmissionStatusRequest, Citation, CitationsApiService, CitationsByDomain, ClosedStatus, CompetitorLocation, ConditionalField, Configuration, ConnectedDirectSyncAccount, CreateAddonAttributesRequest, CreateCompetitors, CreateListingProfileRequest, CreateListingProfileResponse, CreateListingSourceRequest, CreateOperation, CreatePartnerSettingsRequest, DayOfWeek, DeleteAddonAttributesRequest, DeleteCitationsRequest, DeleteListingProfileRequest, DeleteListingSourceRequest, DeleteSuggestionRequest, DetailedSyndicationStatusResultValue, DetailedSyndicationStatusResults, DirectSyncSource, DoctorDotComCategory, EcosystemSource, ExternalIdentifiers, FetchAndSubmitSourceURLsToCSRequest, FieldMask, FieldStatus, GBPClaimStatus, Geo, GetActiveSEOAddonsRequest, GetActiveSEOAddonsResponse, GetAddonAttributesRequest, GetAddonAttributesResponse, GetAppleBusinessConnectInfoRequest, GetAppleBusinessConnectInfoResponse, GetAttributeMetadataRequest, GetAttributeMetadataResponse, GetBingPlacesInfoRequest, GetBingPlacesInfoResponse, GetBusinessProfileFieldStatusRequest, GetBusinessProfileFieldStatusResponse, GetCitationDataRequest, GetCitationDataResponse, GetConfigurationRequest, GetConfigurationResponse, GetDataForSEOCategoryRequest, GetDataForSEOCategoryResponse, GetDirectSyncSourceInfoRequest, GetDirectSyncSourceInfoResponse, GetDoctorDotComCategoriesRequest, GetDoctorDotComCategoriesResponse, GetFacebookPageInfoRequest, GetFacebookPageInfoResponse, GetGoogleBusinessInfoRequest, GetGoogleBusinessInfoResponse, GetGoogleMyBusinessInsightsDataBucketedRequest, GetGoogleMyBusinessInsightsDataBucketedResponse, GetGoogleMyBusinessInsightsDataRequest, GetGoogleMyBusinessInsightsDataResponse, GetInfoGroupIdRequest, GetInfoGroupIdResponse, GetLDDataRequest, GetLDDataResponse, GetListingDistributionActivationStatusRequest, GetListingDistributionActivationStatusResponse, GetListingSourceByIdRequest, GetListingSourceByIdResponse, GetListingSourceByProviderIdRequest, GetListingSourceByProviderIdResponse, GetListingSourcesRequest, GetListingSourcesResponse, GetListingSourcesResponseSourcesEntry, GetLocalSearchSEODataRequest, GetLocalSearchSEODataResponse, GetMoreHoursTypesRequest, GetMoreHoursTypesResponse, GetMultiAddonAttributesRequest, GetMultiAddonAttributesResponse, GetMultiAddonAttributesResponseAddonAttributesEntry, GetMultiListingProfileRequest, GetMultiListingProfileResponse, GetMultiListingProfileResponseListingProfileContainer, GetMultiSuggestionRequest, GetMultiSuggestionResponse, GetNeustarPublicationsRequest, GetNeustarPublicationsResponse, GetOrGenerateSEOSuggestedKeywordsRequest, GetOrGenerateSEOSuggestedKeywordsResponse, GetPartnerSettingsRequest, GetPartnerSettingsResponse, GetPartnerSourcesRequest, GetPartnerSourcesResponse, GetPartnerSourcesResponseSourcesEntry, GetProductSettingsRequest, GetProductSettingsResponse, GetSEODataRequest, GetSEODataResponse, GetSEODataSummaryRequest, GetSEODataSummaryResponse, GetSEOSettingsRequest, GetSEOSuggestedKeywordsRequest, GetSEOSuggestedKeywordsResponse, GetSuggestionRequest, GetSuggestionResponse, GetSyncDataRequest, GetSyncDataResponse, GetSyndicationInfoRequest, GetSyndicationInfoResponse, GoogleAttribute, GoogleAttributeMetaData, GoogleAttributeMetaDataList, GoogleAttributes, GoogleDate, GooglePlace, HealthCareProfessionalInformation, HealthCareProfessionalInformationGender, HealthCareProfessionalInformationIsProvider, HistoricalCitationsDataPoint, HostService, HoursOfOperation, HoursOfOperationSpan, Insight, InsightBucket, InsightBucketed, IsAvailable, IsLocalSEOProActiveForAccountRequest, IsLocalSEOProActiveForAccountResponse, IsPartnerUserRequest, IsPartnerUserResponse, KeywordInfo, LegacyAPICreateRequest, LegacyAPIUpdateRequest, LegacyProductDetails, LifecycleStage, ListSuggestionRequest, ListSuggestionResponse, ListingProductsApiService, ListingProductsService, ListingProfile, ListingProfileApiService, ListingSourceApiService, LocalSearchData, LocalSearchResult, LocalSearchReviews, Location, LocationOverride, ManuallyDeactivateUberallProvisioningRequest, ManuallyFixYextProvisioningRequest, ManuallyProvisionUberallRequest, MarketingClassification, MarketingInfo, Metadata, MoreHoursType, NeustarPublication, PartnerOverride, PartnerSettingsApiService, ProjectionFilter, Provider, ProviderType, ReadFilter, RegularHoursPeriod, RichData, RichDataPaymentMethods, SEOApiService, SEOData, SEODataSummary, SEOSettingsResponse, SEOSuggestedKeywordsApiService, SaveSEOSettingsRequest, ServiceArea, ServiceAreaBusinessType, ServiceAvailability, SocialURLs, Source, SourceAccuracy, SourceLocationSpecificOverridesEntry, SourcePartnerSpecificOverridesEntry, SpecialHoursPeriod, SpecialHoursStatus, StartBusinessDataScoreWorkflowRequest, StartCitationWorkflowRequest, StartLocalSEODataWorkflowRequest, StartSEOCategoryWorkflowRequest, SubmitTurboListerRequest, SubmitTurboListerResponse, SuggestFieldUpdateRequest, SuggestFieldUpdateResponse, Suggestion, SuggestionApiService, SyncData, SyncRequirement, SyncStatus, SyncToSourcesRequest, SyndicationInfo, SyndicationStatus, TimeOfDay, TriggerBingInsightsBackFillRequest, UndeleteListingSourceRequest, UpdateAddonAttributesRequest, UpdateListingProfileRequest, UpdateListingSourceRequest, UpdateListingSourceResponse, UpdateOperation, UpdateOption, UpdateVendorSyncFlagRequest, UpsertPartnerSettingsRequest, UpsertSuggestionRequest, ValueType, VendorAttributeMetaData, Vicinity };
